// src/pages/PayoutPage.js

import { Header } from '../components/Header.js';
import { Footer } from '../components/Footer.js';
import { Notification } from '../components/Notification.js';
import { api } from '../services/api.js';
import { authService } from '../services/authService.js';
import moment from 'moment-timezone';

const VENEZUELA_TIMEZONE = 'America/Caracas';

export function PayoutPage() {
    const page = document.createElement('div');
    page.className = 'page payout-page';

    // 1. Verificación de Seguridad (Solo Agentes de Pago o Admins)
    const currentUser = authService.getCurrentUser();
    
    if (!currentUser || (currentUser.role !== 'payout_agent' && currentUser.role !== 'admin')) {
        page.innerHTML = `
            <div style="display:flex; justify-content:center; align-items:center; min-height:100vh; background:#0f172a;">
                <div style="background:#1e293b; padding:40px; border-radius:12px; border:1px solid #ef4444; text-align:center; max-width:400px; width:90%;">
                    <i class="fas fa-shield-alt" style="font-size:4rem; color:#ef4444; margin-bottom:20px;"></i>
                    <h2 style="color:white; margin-top:0;">Acceso Denegado</h2>
                    <p style="color:#94a3b8;">Esta área es exclusiva para Operadores y Socios B2B.</p>
                    <button class="tabler-btn btn-primary" style="width:100%; margin-top:20px; padding:12px;" onclick="window.location.href='/login'">Volver al Login</button>
                </div>
            </div>
        `;
        return page;
    }

    const mainContent = document.createElement('main');
    mainContent.className = 'tabler-main-container';
    page.appendChild(mainContent);

    const notificationContainer = document.createElement('div');
    notificationContainer.className = 'notification-container';
    mainContent.appendChild(notificationContainer);

    // =========================================================================
    // 🎨 MOTOR DE ESTILOS TABLER UI (DARK MODE PREMIUM & MOBILE FIRST)
    // =========================================================================
    const styleElement = document.createElement('style');
    styleElement.textContent = `
        /* RESET Y AISLAMIENTO DE SCROLL */
        * { box-sizing: border-box; -webkit-tap-highlight-color: transparent; }
        
        .payout-page { 
            background-color: #0f172a !important; 
            color: #f8fafc; 
            font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif; 
            min-height: 100vh; 
            width: 100% !important; 
            margin: 0 !important;
            padding-bottom: 80px; 
            position: absolute; top: 0; left: 0; right: 0; bottom: 0;
            overflow-y: auto !important; overflow-x: hidden !important;
        }
        
        .tabler-main-container { 
            width: 100% !important; max-width: 1400px !important; margin: 0 auto !important; padding: 24px !important; 
        }

        h2, h3, h4, h5 { font-weight: 600; margin-top: 0; }
        
        /* HEADER DEL OPERADOR */
        .page-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 1.5rem; flex-wrap: wrap; gap: 1rem; border-bottom: 1px solid #334155; padding-bottom: 1.5rem; }
        .page-title { margin: 0; font-size: 1.75rem; color: #f8fafc; display: flex; align-items: center; gap: 0.5rem; font-weight: 700; }
        .page-subtitle { color: #94a3b8; font-size: 0.95rem; margin-top: 0.25rem; }
        
        /* TARJETAS (CARDS) TABLER */
        .tabler-card, .content-card { 
            background: #1e293b; border: 1px solid #334155; border-radius: 8px; 
            box-shadow: 0 1px 3px rgba(0,0,0,0.1); margin-bottom: 1.5rem; overflow: hidden; 
        }
        .tabler-card-body { padding: 1.5rem; }
        .content-desc { color: #94a3b8; margin-bottom: 1.5rem; line-height: 1.5; font-size: 0.95rem; }
        .tabler-card-header { padding: 1.25rem 1.5rem; border-bottom: 1px solid #334155; display: flex; justify-content: space-between; align-items: center; background: rgba(255,255,255,0.01); flex-wrap: wrap; gap: 10px; }
        .tabler-card-title { margin: 0; font-size: 1.15rem; color: #f8fafc; font-weight: 600; display: flex; align-items: center; gap: 0.5rem; }

        /* WIDGETS FINANCIEROS (RESUMEN) */
        .widget-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 1rem; margin-bottom: 1.5rem; }
        .widget-box { background: #1e293b; border: 1px solid #334155; border-radius: 8px; padding: 1.25rem; position: relative; overflow: hidden; transition: transform 0.2s; }
        .widget-box:hover { transform: translateY(-2px); box-shadow: 0 4px 6px -1px rgba(0,0,0,0.2); }
        .widget-box::before { content: ''; position: absolute; left: 0; top: 0; bottom: 0; width: 4px; border-radius: 8px 0 0 8px; }
        .widget-box.primary::before { background: #3b82f6; }
        .widget-box.success::before { background: #10b981; }
        .widget-box.danger::before { background: #ef4444; }
        .widget-box.warning::before { background: #f59e0b; }
        .widget-box.gold::before { background: #D4AF37; }
        
        .widget-title { color: #94a3b8; font-size: 0.75rem; font-weight: 700; text-transform: uppercase; margin-bottom: 0.5rem; letter-spacing: 0.05em; }
        .widget-value { color: #f8fafc; font-size: 1.75rem; font-weight: 700; font-family: ui-monospace, monospace; line-height: 1.2; }

        /* NAVEGACIÓN PRINCIPAL (MENU GRID) */
        .menu-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); gap: 1rem; margin-top: 1rem; }
        .menu-item { 
            background: #1e293b; border: 1px solid #334155; border-radius: 8px; padding: 1.5rem; 
            cursor: pointer; transition: all 0.2s; display: flex; align-items: flex-start; gap: 1rem; 
        }
        .menu-item:hover { border-color: #3b82f6; background: #232f45; transform: translateY(-3px); box-shadow: 0 10px 15px -3px rgba(0,0,0,0.2); }
        .menu-icon { 
            width: 48px; height: 48px; border-radius: 8px; display: flex; align-items: center; justify-content: center; 
            font-size: 1.5rem; flex-shrink: 0; 
        }
        .menu-text h4 { margin: 0 0 0.25rem 0; color: #f8fafc; font-size: 1.1rem; font-weight: 600; }
        .menu-text p { margin: 0; color: #94a3b8; font-size: 0.85rem; line-height: 1.4; }

        /* BOTONES TABLER */
        .tabler-btn, .btn-action, .btn-primary, .btn-success, .btn-danger, .btn-secondary, .btn-warning, .btn-info { 
            display: inline-flex; align-items: center; justify-content: center; gap: 0.5rem; padding: 0.6rem 1.2rem; 
            font-size: 0.875rem; font-weight: 600; border-radius: 6px; cursor: pointer; transition: all 0.2s; border: 1px solid transparent; text-transform: none; letter-spacing: normal;
        }
        .btn-primary { background: #D4AF37; color: #000; }
        .btn-primary:hover:not(:disabled) { background: #FCD34D; transform: translateY(-1px); box-shadow: 0 4px 6px rgba(0,0,0,0.1); }
        .btn-success { background: #10b981; color: white; border-color: #10b981; }
        .btn-danger { background: #ef4444; color: white; border-color: #ef4444; }
        .btn-secondary { background: #334155; color: #f8fafc; border-color: #475569; }
        .btn-secondary:hover:not(:disabled) { background: #475569; }
        button:disabled { opacity: 0.6; cursor: not-allowed; }

        /* FORMULARIOS E INPUTS */
        .form-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 1.25rem; margin-bottom: 1.5rem; align-items: end; }
        .form-group { display: flex; flex-direction: column; width: 100%; }
        .form-group label { color: #94a3b8; font-size: 0.8rem; margin-bottom: 0.5rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.05em; }
        .remate-input, .remate-select, .tabler-input, .tabler-select { 
            width: 100%; padding: 0.75rem 1rem; background: #0f172a; border: 1px solid #475569; 
            color: #f8fafc; border-radius: 6px; font-size: 0.95rem; outline: none; transition: border-color 0.2s, box-shadow 0.2s; 
            font-family: inherit;
        }
        .remate-input:focus, .remate-select:focus, .tabler-input:focus, .tabler-select:focus { border-color: #D4AF37; box-shadow: 0 0 0 2px rgba(212, 175, 55, 0.2); }
        select option { background-color: #1e293b; color: #f8fafc; }

        /* TABS MATERIAL */
        .profile-tabs, .nav-tabs { display: flex; border-bottom: 1px solid #334155; margin-bottom: 1.5rem; overflow-x: auto; scrollbar-width: none; flex-wrap: wrap; }
        .profile-tabs::-webkit-scrollbar, .nav-tabs::-webkit-scrollbar { display: none; }
        .profile-tab, .nav-tab { 
            flex: 1; min-width: max-content; padding: 1rem 1.5rem; background: transparent; color: #94a3b8; 
            border: none; border-bottom: 2px solid transparent; cursor: pointer; font-weight: 600; font-size: 0.9rem; 
            text-transform: uppercase; letter-spacing: 1px; transition: color 0.2s;
        }
        .profile-tab:hover, .nav-tab:hover { color: #f8fafc; background: rgba(255,255,255,0.04); }
        .profile-tab.active, .nav-tab.active { color: #D4AF37; border-bottom-color: #D4AF37; }

        /* TABLAS MATERIAL */
        .table-responsive, .tabler-table-container { overflow-x: auto; width: 100%; border-radius: 8px; border: 1px solid #334155; background: #1e293b; }
        .remate-table, .tabler-table { width: 100%; border-collapse: collapse; text-align: left; }
        .remate-table th, .tabler-table th { background: #0f172a; color: #94a3b8; padding: 12px 16px; font-size: 0.75rem; text-transform: uppercase; border-bottom: 1px solid #334155; font-weight: 600; letter-spacing: 0.05em; }
        .remate-table td, .tabler-table td { padding: 12px 16px; color: #f8fafc; border-bottom: 1px solid #334155; font-size: 0.875rem; vertical-align: middle; }
        .remate-table tbody tr:hover, .tabler-table tbody tr:hover { background-color: rgba(255,255,255,0.02); }
        .remate-table tr:last-child td, .tabler-table tr:last-child td { border-bottom: none; }
        .td-bold { font-weight: 600; font-size: 1rem; }
        .td-mono, .font-mono { font-family: ui-monospace, monospace; font-weight: 700; font-size: 1.05rem; }

        /* MODALES MATERIAL */
        .modal-overlay, .tabler-modal-overlay { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(15, 23, 42, 0.85); display: flex; justify-content: center; align-items: center; z-index: 10000; opacity: 0; visibility: hidden; transition: opacity 0.2s; backdrop-filter: blur(4px); }
        .modal-overlay.visible, .tabler-modal-overlay.visible { opacity: 1; visibility: visible; }
        .modal-content, .tabler-modal-content { background: #1e293b; border-radius: 8px; padding: 24px; width: 95%; max-width: 550px; box-shadow: 0 10px 25px rgba(0,0,0,0.5); transform: scale(0.95); transition: transform 0.2s; max-height: 90vh; overflow-y: auto; border: 1px solid #334155; }
        .modal-overlay.visible .modal-content, .tabler-modal-overlay.visible .tabler-modal-content { transform: scale(1); }
        .modal-header, .tabler-modal-header { margin-bottom: 1.5rem; text-align: left; border-bottom: 1px solid #334155; padding-bottom: 1rem; }
        .modal-header h3, .tabler-modal-header h3 { color: #f8fafc; font-size: 1.25rem; margin: 0 0 0.5rem 0; display: flex; align-items: center; gap: 0.5rem; font-weight: 600; }
        .modal-actions, .tabler-modal-actions { display: flex; gap: 1rem; margin-top: 1.5rem; padding-top: 1.5rem; border-top: 1px solid #334155; }
        .modal-actions button, .tabler-modal-actions button { flex: 1; }

        /* TREE GRID DEL HISTORIAL */
        .hist-tree-node, .mon-tree-node { background: #0f172a; border: 1px solid #334155; border-radius: 8px; margin-bottom: 10px; overflow: hidden; }
        .hist-tree-header, .mon-tree-header { display: flex; justify-content: space-between; align-items: center; padding: 12px 16px; cursor: pointer; transition: 0.2s; background: #1e293b; border-bottom: 1px solid transparent; }
        .hist-tree-header:hover, .mon-tree-header:hover { background: #232f45; border-color: #3b82f6; }
        .hist-tree-header.active, .mon-tree-header.active { border-bottom: 1px solid #334155; }
        .hist-tree-child, .mon-tree-child { display: none; padding: 0; background: #0f172a; overflow-x: auto; }
        .hist-tree-child.open, .mon-tree-child.open { display: block; animation: slideDown 0.3s ease forwards; }

        .badge-status { padding: 4px 8px; border-radius: 4px; font-size: 0.7rem; font-weight: 700; text-align: center; text-transform: uppercase; border: 1px solid transparent; display: inline-block; min-width: 80px;}
        .status-WON { background: rgba(16,185,129,0.1); color: #34d399; border-color: rgba(16,185,129,0.2); }
        .status-LOST { background: rgba(239,68,68,0.1); color: #f87171; border-color: rgba(239,68,68,0.2); }
        .status-PENDING { background: rgba(59,130,246,0.1); color: #60a5fa; border-color: rgba(59,130,246,0.2); }
        .status-SCRATCHED { background: rgba(148,163,184,0.1); color: #94a3b8; border-color: rgba(148,163,184,0.2); }

        .hidden { display: none !important; }
        .text-success { color: #10b981 !important; }
        .text-danger { color: #ef4444 !important; }
        .text-warning { color: #f59e0b !important; }
        .text-muted { color: #94a3b8 !important; }
        
        .loader-container { text-align: center; padding: 40px 0; color: #94a3b8; }
        .loader-container i { font-size: 2.5rem; color: #D4AF37; margin-bottom: 16px; }

        @keyframes slideDown { from { opacity: 0; transform: translateY(-10px); } to { opacity: 1; transform: translateY(0); } }

        /* ADAPTACIÓN MÓVIL ESTRICTA */
        @media (max-width: 768px) {
            .tabler-main-container { padding: 12px !important; }
            .page-header { flex-direction: column; align-items: flex-start; gap: 1rem; border-bottom: none; padding-bottom: 0; }
            .tabler-btn, .btn-primary, .btn-secondary, .btn-success, .btn-danger { width: 100%; justify-content: center; }
            .widget-grid { grid-template-columns: 1fr 1fr; gap: 0.75rem; } 
            .menu-grid { grid-template-columns: 1fr; } 
            .tabler-card-header { flex-direction: column; align-items: flex-start; }
            .form-grid { grid-template-columns: 1fr; gap: 1rem; }
            .modal-content, .tabler-modal-content { max-width: 100%; border-radius: 16px 16px 0 0; position: absolute; bottom: 0; transform: translateY(100%); padding: 20px; }
            .modal-overlay.visible .modal-content, .tabler-modal-overlay.visible .tabler-modal-content { transform: translateY(0); }
            .modal-actions, .tabler-modal-actions { flex-direction: column; }
            .mon-tree-header, .hist-tree-header { flex-direction: column; align-items: flex-start; gap: 10px; }
            .mon-tree-header > div, .hist-tree-header > div { width: 100%; display: flex; justify-content: space-between; }
        }
        @media (max-width: 480px) {
            .widget-grid { grid-template-columns: 1fr; } 
        }
    `;
    page.appendChild(styleElement);

    // --- ESTADO GLOBAL DEL CAJERO (AUDITORÍA DE COMISIONES) ---
    let cashierState = {
        myClients: [],
        exchangeRate: 0,
        myClientIds: new Set(),
        comisionRate: 20, // Por defecto 20%
        commissionType: 'PERCENT' // Nuevo soporte: PERCENT, PERCENT_SALES, FIXED
    };

    // --- HEADER PRINCIPAL ---
    const headerTitle = document.createElement('div');
    headerTitle.className = 'page-header';
    headerTitle.innerHTML = `
        <div>
            <h2 class="page-title"><i class="fas fa-store" style="color: #D4AF37;"></i> Panel de Operador</h2>
            <div class="page-subtitle">Taquilla / Socio: <b style="color: #f8fafc;">${currentUser.username}</b></div>
        </div>
        <button id="logoutBtn" class="tabler-btn btn-secondary"><i class="fas fa-sign-out-alt"></i> Cerrar Sesión</button>
    `;
    mainContent.appendChild(headerTitle);

    const homeView = document.createElement('div');
    homeView.id = 'homeView';
    mainContent.appendChild(homeView);

    const detailView = document.createElement('section');
    detailView.id = 'detailView';
    detailView.className = 'hidden';
    mainContent.appendChild(detailView);

    headerTitle.querySelector('#logoutBtn').onclick = () => { authService.logout(); window.location.href = '/login'; };

    // --- FUNCIONES DE CARGA DE DATOS CENTRALIZADAS ---
    const loadGlobalData = async () => {
        try {
            // 1. Tasa de Cambio y Configuración de Comisiones
            const confData = await api.get('/configs/cashier'); 
            const configsArr = Array.isArray(confData) ? confData : [confData];
            
            const myConfig = configsArr.find(c => c.user_id === currentUser.id) || {};
            const globalConfig = configsArr.find(c => c.user_id === 1) || configsArr[0] || {};

            cashierState.exchangeRate = parseFloat(globalConfig.exchange_rate || 0);
            cashierState.commissionType = myConfig.commission_type || 'PERCENT';
            cashierState.comisionRate = parseFloat(myConfig.commission_value || 20);

            // 2. Extraer mis clientes
            const users = await api.get('/remate/users');
            cashierState.myClients = users.filter(u => u.ally_name === currentUser.username);
            cashierState.myClientIds = new Set(cashierState.myClients.map(u => u.id));

        } catch (error) {
            console.error("Error inicializando datos:", error);
        }
    };

    // =========================================================================
    // 🏠 VISTA: HOME / DASHBOARD EJECUTIVO (RESUMEN DIARIO Y CIERRE)
    // =========================================================================
    const renderHome = async () => {
        homeView.innerHTML = `
            <div class="tabler-card">
                <div class="tabler-card-header">
                    <h3 class="tabler-card-title"><i class="fas fa-chart-pie text-muted"></i> Liquidación de Hoy</h3>
                    <span style="font-size: 0.8rem; color: #94a3b8; background: #0f172a; padding: 4px 10px; border-radius: 4px; border: 1px solid #334155;">
                        <i class="fas fa-handshake text-success"></i> Acuerdo: <b style="color:white;">${cashierState.commissionType === 'FIXED' ? 'Fijo $' : (cashierState.commissionType === 'PERCENT_SALES' ? '% de Venta' : '% Neto')}</b> (${cashierState.comisionRate})
                    </span>
                </div>
                <div class="tabler-card-body" style="padding-bottom: 0.5rem;">
                    <div class="widget-grid">
                        <div class="widget-box primary">
                            <div class="widget-title">Venta Bruta (Handle)</div>
                            <div class="widget-value text-blue-400" id="val-played"><i class="fas fa-spinner fa-spin"></i></div>
                        </div>
                        <div class="widget-box danger">
                            <div class="widget-title">Premios Pagados</div>
                            <div class="widget-value text-red-400" id="val-paid"><i class="fas fa-spinner fa-spin"></i></div>
                        </div>
                        <div class="widget-box success">
                            <div class="widget-title">Neto Sistema (GGR)</div>
                            <div class="widget-value text-green-400" id="val-net"><i class="fas fa-spinner fa-spin"></i></div>
                        </div>
                        <div class="widget-box gold">
                            <div class="widget-title">Tu Comisión Diaria</div>
                            <div class="widget-value text-yellow-400" id="val-comm"><i class="fas fa-spinner fa-spin"></i></div>
                        </div>
                    </div>
                    
                    <!-- PANEL DE CIERRE DE CAJA -->
                    <div id="settlement-panel" style="background: rgba(15, 23, 42, 0.6); border: 1px solid #475569; border-radius: 8px; padding: 24px; margin-bottom: 20px; text-align: center;">
                        <h4 style="color: #cbd5e1; margin: 0 0 10px 0; font-size: 0.95rem; text-transform: uppercase; letter-spacing: 1px;">Liquidación de Caja con Casa Matriz</h4>
                        <div id="val-settlement" style="font-size: 3rem; font-weight: 700; font-family: ui-monospace, monospace; line-height: 1;">
                            <i class="fas fa-spinner fa-spin text-muted" style="font-size: 2rem;"></i>
                        </div>
                        <div id="lbl-settlement" style="color: #94a3b8; font-size: 0.95rem; margin-top: 8px;">Auditando transacciones...</div>
                    </div>
                </div>
            </div>

            <h3 style="color: #f8fafc; font-size: 1.25rem; margin-bottom: 1rem; margin-top: 2rem;"><i class="fas fa-th-large text-muted"></i> Menú Operativo</h3>
            
            <div class="menu-grid">
                <!-- VIP Y REGLAS -->
                <div class="menu-item" id="card-rules">
                    <div class="menu-icon" style="color: #f59e0b; background: rgba(245, 158, 11, 0.1);"><i class="fas fa-cogs"></i></div>
                    <div class="menu-text">
                        <h4>Reglas y Logros</h4>
                        <p>Configura tu Mantequilla y multiplicadores.</p>
                    </div>
                </div>
                <div class="menu-item" id="card-custom">
                    <div class="menu-icon" style="color: #10b981; background: rgba(16, 185, 129, 0.1);"><i class="fas fa-calendar-check"></i></div>
                    <div class="menu-text">
                        <h4>Remates Anticipados</h4>
                        <p>Abre y gestiona tus carreras exclusivas.</p>
                    </div>
                </div>
                <div class="menu-item" id="card-vip">
                    <div class="menu-icon" style="color: #8b5cf6; background: rgba(139, 92, 246, 0.1);"><i class="fas fa-crown"></i></div>
                    <div class="menu-text">
                        <h4>Salas VIP Privadas</h4>
                        <p>Crea remates cerrados por invitación.</p>
                    </div>
                </div>
                
                <!-- OPERACIÓN ESTÁNDAR -->
                <div class="menu-item" id="card-clients">
                    <div class="menu-icon" style="color: #3b82f6; background: rgba(59, 130, 246, 0.1);"><i class="fas fa-users"></i></div>
                    <div class="menu-text">
                        <h4>Cartera de Clientes (${cashierState.myClients.length})</h4>
                        <p>Gestión de saldos, límites e historial.</p>
                    </div>
                </div>
                <div class="menu-item" id="card-withdraws">
                    <div class="menu-icon" style="color: #D4AF37; background: rgba(212, 175, 55, 0.1);"><i class="fas fa-hand-holding-usd"></i></div>
                    <div class="menu-text">
                        <h4>Solicitudes de Retiro</h4>
                        <p>Aprueba o rechaza pagos a clientes.</p>
                    </div>
                </div>
                <div class="menu-item" id="card-live-monitor"> 
                    <div class="menu-icon" style="color: #ef4444; background: rgba(239, 68, 68, 0.1);"><i class="fas fa-satellite-dish"></i></div>
                    <div class="menu-text">
                        <h4>Auditoría en Vivo</h4>
                        <p>Monitor de apuestas Win/Place y Remates.</p>
                    </div>
                </div>
                <div class="menu-item" id="card-reports">
                    <div class="menu-icon" style="color: #94a3b8; background: rgba(148, 163, 184, 0.1);"><i class="fas fa-file-invoice-dollar"></i></div>
                    <div class="menu-text">
                        <h4>Cuadre de Caja (Histórico)</h4>
                        <p>Balance de fechas anteriores.</p>
                    </div>
                </div>
                <div class="menu-item" id="card-qr">
                    <div class="menu-icon" style="color: #f8fafc; background: rgba(248, 250, 252, 0.1);"><i class="fas fa-qrcode"></i></div>
                    <div class="menu-text">
                        <h4>Compartir App</h4>
                        <p>Código QR y Link directo de afiliación.</p>
                    </div>
                </div>
                <div class="menu-item" id="card-chat">
                    <div class="menu-icon" style="color: #10b981; background: rgba(16, 185, 129, 0.1);"><i class="fas fa-comments"></i></div>
                    <div class="menu-text">
                        <h4>Gestor de Mensajes</h4>
                        <p>Chat en vivo con tus clientes en salas.</p>
                    </div>
                </div>
            </div>
        `;

        try {
            const todayStr = moment().tz(VENEZUELA_TIMEZONE).format('YYYY-MM-DD');
            const params = new URLSearchParams({
                startDate: `${todayStr} 00:00:00`,
                endDate: `${todayStr} 23:59:59`,
                allyName: currentUser.username 
            });

            const data = await api.get(`/remate/reports/detailed-bets?${params.toString()}`);
            
            let todayPlayed = 0; let todayPaid = 0;
            if (Array.isArray(data)) {
                data.forEach(b => {
                    const isOutbidOrRefunded = b.category === 'REMATE' && (b.status === 'lost' || b.status === 'refunded' || b.status === 'scratched');
                    if (!isOutbidOrRefunded) {
                        todayPlayed += parseFloat(b.amount || 0);
                    }
                    // ⭐ FIX: Convertir pagos de REMATE (guardados en Bs) a USD
                    let rawPayout = parseFloat(b.payout || 0);
                    if (b.category === 'REMATE' && rawPayout > 0 && cashierState.exchangeRate > 0) {
                        rawPayout = rawPayout / cashierState.exchangeRate;
                    }
                    todayPaid += rawPayout;
                });
            }

            // Matemática Financiera de Auditoría
            const netProfit = todayPlayed - todayPaid;
            
            let estimatedComm = 0;
            if (cashierState.commissionType === 'PERCENT' && netProfit > 0) estimatedComm = netProfit * (cashierState.comisionRate / 100);
            else if (cashierState.commissionType === 'PERCENT_SALES') estimatedComm = todayPlayed * (cashierState.comisionRate / 100);
            else if (cashierState.commissionType === 'FIXED' && todayPlayed > 0) estimatedComm = cashierState.comisionRate;

            // Liquidación: Si el operador retiene el efectivo del cliente, le debe el Neto menos su comisión a la casa.
            const settlement = netProfit - estimatedComm;

            homeView.querySelector('#val-played').textContent = `$${todayPlayed.toFixed(2)}`;
            homeView.querySelector('#val-paid').textContent = `$${todayPaid.toFixed(2)}`;
            homeView.querySelector('#val-net').textContent = `${netProfit >= 0 ? '+' : ''}$${netProfit.toFixed(2)}`;
            homeView.querySelector('#val-net').className = `widget-value ${netProfit >= 0 ? 'text-success' : 'text-danger'}`;
            homeView.querySelector('#val-comm').textContent = `$${estimatedComm.toFixed(2)}`;

            const settlementDiv = homeView.querySelector('#val-settlement');
            const settlementLbl = homeView.querySelector('#lbl-settlement');

            if (settlement > 0) {
                // Operador ganó, debe entregar la diferencia a la casa
                settlementDiv.textContent = `$${settlement.toFixed(2)}`;
                settlementDiv.className = 'text-danger';
                settlementLbl.innerHTML = '<i class="fas fa-arrow-up text-danger"></i> Debes liquidar este monto a la Casa Matriz.';
            } else if (settlement < 0) {
                // Pérdidas o comisión supera el neto, la casa debe pagarle al operador
                settlementDiv.textContent = `$${Math.abs(settlement).toFixed(2)}`;
                settlementDiv.className = 'text-success';
                settlementLbl.innerHTML = '<i class="fas fa-arrow-down text-success"></i> La Casa Matriz debe liquidarte este monto a ti.';
            } else {
                settlementDiv.textContent = `$0.00`;
                settlementDiv.className = 'text-muted';
                settlementLbl.innerHTML = '<i class="fas fa-check-circle"></i> Caja en cero. No hay deudas pendientes hoy.';
            }

        } catch (e) {
            homeView.querySelector('#val-played').textContent = "Error";
            homeView.querySelector('#val-paid').textContent = "Error";
            homeView.querySelector('#val-comm').textContent = "Error";
            homeView.querySelector('#val-settlement').textContent = "Error";
        }

        // Asignación de enrutadores
        homeView.querySelector('#card-clients').onclick = () => renderSection('clients');
        homeView.querySelector('#card-withdraws').onclick = () => renderSection('withdraws');
        homeView.querySelector('#card-reports').onclick = () => renderSection('reports');
        homeView.querySelector('#card-qr').onclick = () => renderSection('app-qr');
        homeView.querySelector('#card-chat').onclick = () => renderSection('chat-manager'); // <-- AÑADIR ESTO
        homeView.querySelector('#card-live-monitor').onclick = () => renderSection('live-monitor');
        homeView.querySelector('#card-rules').onclick = () => renderSection('my-rules');
        homeView.querySelector('#card-vip').onclick = () => renderSection('my-vip-rooms');
        homeView.querySelector('#card-custom').onclick = () => renderSection('my-custom-races');
    };

    // --- NAVEGADOR PRINCIPAL DE SECCIONES ---
    async function renderSection(sectionId) {
        homeView.classList.add('hidden');
        detailView.classList.remove('hidden');
        
        window.scrollTo({ top: 0, behavior: 'smooth' });

        detailView.innerHTML = `
            <div class="tabler-card" style="margin-bottom: 20px; background: transparent; border: none; box-shadow: none;">
                <div class="tabler-card-header" style="background: transparent; border-bottom: 1px solid #334155; padding: 0 0 15px 0;">
                    <h3 id="section-title" class="tabler-card-title" style="font-size: 1.3rem;">Cargando...</h3>
                    <button class="tabler-btn btn-secondary" id="backToHomeBtn"><i class="fas fa-arrow-left"></i> Volver al Panel</button>
                </div>
            </div>
            <div id="section-content"></div>
        `;

        detailView.querySelector('#backToHomeBtn').onclick = () => { 
            detailView.classList.add('hidden'); 
            homeView.classList.remove('hidden'); 
            window.scrollTo({ top: 0, behavior: 'smooth' });
            loadGlobalData().then(renderHome); 
        };

        const contentDiv = detailView.querySelector('#section-content');
        const titleEl = detailView.querySelector('#section-title');

        await loadGlobalData();

        if (sectionId === 'clients') {
            titleEl.innerHTML = `<i class="fas fa-users text-blue-400"></i> Cartera de Clientes`;
            renderClients(contentDiv); 
        } else if (sectionId === 'withdraws') {
            titleEl.innerHTML = `<i class="fas fa-hand-holding-usd text-yellow-400"></i> Gestión de Retiros`;
            renderWithdrawals(contentDiv); 
        } else if (sectionId === 'reports') {
            titleEl.innerHTML = `<i class="fas fa-file-invoice-dollar text-gray-400"></i> Cuadre de Caja Histórico`;
            renderReports(contentDiv); 
        } else if (sectionId === 'live-monitor') { 
            titleEl.innerHTML = `<i class="fas fa-satellite-dish text-red-400"></i> Auditoría Financiera en Vivo`;
            renderLiveMonitor(contentDiv); 
        } else if (sectionId === 'app-qr') {
            titleEl.innerHTML = `<i class="fas fa-qrcode text-white"></i> Compartir App Móvil`;
            renderQRApp(contentDiv); 
        } else if (sectionId === 'my-rules') {
            titleEl.innerHTML = `<i class="fas fa-cogs text-yellow-500"></i> Mis Reglas y Condicionados`;
            renderMyRules(contentDiv); 
        } else if (sectionId === 'my-custom-races') {
            titleEl.innerHTML = `<i class="fas fa-calendar-check text-green-500"></i> Remates Anticipados (Exclusivos)`;
            renderMyCustomRaces(contentDiv); 
        } else if (sectionId === 'my-vip-rooms') {
            titleEl.innerHTML = `<i class="fas fa-crown text-purple-500"></i> Mis Salas VIP (Privadas)`;
            renderMyVipRooms(contentDiv); 
        } else if (sectionId === 'chat-manager') {
            titleEl.innerHTML = `<i class="fas fa-comments text-green-500"></i> Centro de Mensajería`;
            renderChatManager(contentDiv); 
        }
    }

    // =========================================================================
    // 👥 VISTA: GESTIÓN DE CARTERA DE CLIENTES
    // =========================================================================
    const renderClients = (container) => {
        container.innerHTML = `
            <div class="tabler-card">
                <div class="tabler-card-header">
                    <h3 class="tabler-card-title"><i class="fas fa-users text-blue-400"></i> Directorio de Clientes</h3>
                    <button id="refreshClientsBtn" class="tabler-btn btn-outline"><i class="fas fa-sync-alt"></i> Actualizar</button>
                </div>
                <div class="tabler-card-body">
                    <p class="content-desc">Busca a tus clientes, ajusta sus límites de riesgo y gestiona sus saldos manualmente.</p>
                    
                    <div class="form-group" style="max-width: 400px; margin-bottom: 1.5rem;">
                        <div style="position: relative;">
                            <i class="fas fa-search" style="position: absolute; left: 14px; top: 12px; color: #64748b;"></i>
                            <input type="text" id="searchClient" class="tabler-input" placeholder="Buscar por nombre o teléfono..." style="padding-left: 40px;">
                        </div>
                    </div>

                    <div class="tabler-table-container">
                        <table class="tabler-table">
                            <thead>
                                <tr>
                                    <th>Cliente</th>
                                    <th>Contacto</th>
                                    <th class="text-right">Saldo ($)</th>
                                    <th class="text-right">Saldo (Bs)</th>
                                    <th class="text-center">Acciones Operativas</th>
                                </tr>
                            </thead>
                            <tbody id="clientsBody"></tbody>
                        </table>
                    </div>
                </div>
            </div>
        `;

        const renderTable = (usersArray) => {
            const tbody = container.querySelector('#clientsBody');
            if (usersArray.length === 0) {
                tbody.innerHTML = '<tr><td colspan="5" class="text-center text-muted" style="padding: 40px 0;">No tienes clientes asociados aún o no coinciden con la búsqueda.</td></tr>';
                return;
            }
            tbody.innerHTML = usersArray.map(u => {
                const balUsd = parseFloat(u.balance_usd || 0).toFixed(2);
                const balBs = (parseFloat(u.balance_usd || 0) * cashierState.exchangeRate).toFixed(2);
                const name = u.alias || u.first_name || u.username || `ID: ${u.telegram_id}`;
                return `
                    <tr>
                        <td>
                            <div style="font-weight:600; color:#f8fafc; font-size:1rem;">${name}</div>
                        </td>
                        <td class="text-muted">${u.phone_number || 'No Registrado'}</td>
                        <td class="text-right font-mono" style="color: #10b981; font-weight:700; font-size:1.05rem;">$${balUsd}</td>
                        <td class="text-right font-mono text-muted">Bs ${balBs}</td>
                        <td class="text-center">
                            <div style="display: flex; gap: 8px; justify-content: center; flex-wrap: wrap;">
                                <button class="tabler-btn btn-primary btn-manage-balance" data-id="${u.id}" style="flex:1; min-width:120px;">
                                    <i class="fas fa-wallet"></i> Caja y Límites
                                </button>
                                <button class="tabler-btn btn-secondary btn-history" data-id="${u.id}" style="flex:1; min-width:100px;">
                                    <i class="fas fa-list-ul"></i> Historial
                                </button>
                            </div>
                        </td>
                    </tr>
                `;
            }).join('');

            container.querySelectorAll('.btn-manage-balance').forEach(btn => {
                btn.onclick = () => {
                    const user = cashierState.myClients.find(u => u.id == btn.dataset.id);
                    openBalanceModal(user, () => {
                        loadGlobalData().then(() => renderTable(cashierState.myClients));
                    });
                };
            });

            container.querySelectorAll('.btn-history').forEach(btn => {
                btn.onclick = () => {
                    const user = cashierState.myClients.find(u => u.id == btn.dataset.id);
                    openHistoryModal(user);
                };
            });
        };

        renderTable(cashierState.myClients);

        container.querySelector('#searchClient').oninput = (e) => {
            const term = e.target.value.toLowerCase();
            const filtered = cashierState.myClients.filter(u => 
                (u.alias && u.alias.toLowerCase().includes(term)) || 
                (u.first_name && u.first_name.toLowerCase().includes(term)) ||
                (u.phone_number && u.phone_number.includes(term))
            );
            renderTable(filtered);
        };

        container.querySelector('#refreshClientsBtn').onclick = async () => {
            container.querySelector('#clientsBody').innerHTML = '<tr><td colspan="5" class="loader-container"><i class="fas fa-spinner fa-spin"></i><br>Cargando clientes...</td></tr>';
            await loadGlobalData();
            renderTable(cashierState.myClients);
        };
    };

    // =========================================================================
    // 📜 MODAL: HISTORIAL TIPO TREE (AGRUPADO POR FECHA - TABLER UI)
    // =========================================================================
    const openHistoryModal = async (user) => {
        const modal = document.createElement('div');
        modal.className = 'tabler-modal-overlay';

        modal.innerHTML = `
            <div class="tabler-modal-content" style="max-width: 700px; padding: 0;">
                <div class="tabler-modal-header" style="margin: 0; padding: 20px; background: #1e293b; border-radius: 8px 8px 0 0; position: sticky; top: 0; z-index: 10;">
                    <h3 style="color: #3b82f6;"><i class="fas fa-list-alt"></i> Historial de Movimientos</h3>
                    <p style="color: #94a3b8; font-size: 0.95rem; margin: 0;">Auditoría del Cliente: <b style="color: #f8fafc;">${user.alias || user.username}</b></p>
                </div>
                
                <div id="user-history-content" style="padding: 20px; min-height: 200px;">
                    <div class="loader-container"><i class="fas fa-spinner fa-spin"></i><br>Cargando historial...</div>
                </div>

                <div class="tabler-modal-actions" style="padding: 20px; margin: 0; background: #1e293b; border-radius: 0 0 8px 8px; position: sticky; bottom: 0;">
                    <button id="close-history" class="tabler-btn btn-secondary" style="width: 100%;"><i class="fas fa-times"></i> Cerrar Panel</button>
                </div>
            </div>
        `;
        
        document.body.appendChild(modal);
        setTimeout(() => modal.classList.add('visible'), 10);

        modal.querySelector('#close-history').onclick = () => {
            modal.classList.remove('visible');
            setTimeout(() => modal.remove(), 200);
        };

        const contentDiv = modal.querySelector('#user-history-content');
        
        try {
            const txs = await api.get(`/remate/history?telegramId=${user.telegram_id}&_t=${Date.now()}`);
            
            if (!txs || txs.length === 0) {
                contentDiv.innerHTML = `
                    <div style="text-align: center; padding: 30px; background: rgba(255,255,255,0.02); border-radius: 8px;">
                        <i class="fas fa-receipt" style="font-size: 2.5rem; color: #475569; margin-bottom: 10px;"></i>
                        <p style="color: #94a3b8; margin: 0;">Este usuario no tiene transacciones registradas.</p>
                    </div>`;
                return;
            }

            const groupedTxs = txs.reduce((acc, tx) => {
                const dateObj = new Date(tx.date);
                const dayKey = dateObj.toLocaleDateString('es-VE', { year: 'numeric', month: '2-digit', day: '2-digit' }); 
                
                if(!acc[dayKey]) acc[dayKey] = { dateStr: dayKey, txs: [], totalNet: 0 };
                
                const rate = cashierState.exchangeRate > 0 ? cashierState.exchangeRate : 1;
                const amountUsd = parseFloat(tx.amount) / rate;
                
                if (tx.type === 'WIN' || tx.type === 'DEPOSIT' || tx.type === 'CREDIT') {
                    acc[dayKey].totalNet += amountUsd;
                } else {
                    acc[dayKey].totalNet -= amountUsd;
                }

                acc[dayKey].txs.push({...tx, amountUsd});
                return acc;
            }, {});

            let html = '';
            Object.values(groupedTxs).forEach(group => {
                const netColor = group.totalNet >= 0 ? '#10b981' : '#ef4444';
                const netSign = group.totalNet >= 0 ? '+' : '';
                
                html += `
                <div class="hist-tree-node">
                    <div class="hist-tree-header">
                        <div style="font-weight:600; font-size:1rem; display:flex; align-items:center; gap:12px; color: #f8fafc;">
                            <i class="fas fa-chevron-right text-muted" style="width:15px; transition: 0.2s;"></i>
                            <i class="fas fa-calendar-alt text-blue-400"></i> ${group.dateStr}
                        </div>
                        <div style="text-align: right;">
                            <div style="font-size: 0.7rem; color: #94a3b8; text-transform: uppercase; font-weight:600;">Balance del Día</div>
                            <div class="font-mono" style="font-weight:700; font-size:1.1rem; color:${netColor}">
                                ${netSign}$${group.totalNet.toFixed(2)}
                            </div>
                        </div>
                    </div>
                    <div class="hist-tree-child">
                        <table class="tabler-table" style="margin:0;">
                            <thead>
                                <tr>
                                    <th width="80px">Hora</th>
                                    <th>Detalle</th>
                                    <th class="text-right">Monto</th>
                                </tr>
                            </thead>
                            <tbody>
                                ${group.txs.map(item => {
                                    let icon = 'fa-circle'; let colorClass = '#94a3b8'; let sign = ''; let title = 'Transacción';

                                    if (item.type === 'WIN') { icon = 'fa-trophy'; colorClass = '#D4AF37'; sign = '+'; title = 'PREMIO GANADO'; } 
                                    else if (item.type === 'BET') { icon = 'fa-gavel'; colorClass = '#3b82f6'; sign = '-'; title = 'APUESTA'; } 
                                    else if (item.type === 'DEPOSIT' || item.type === 'CREDIT') { icon = 'fa-arrow-down'; colorClass = '#10b981'; sign = '+'; title = 'RECARGA'; } 
                                    else if (item.type === 'WITHDRAW' || item.type === 'DEBIT') { icon = 'fa-arrow-up'; colorClass = '#ef4444'; sign = '-'; title = 'RETIRO'; }

                                    const timeStr = new Date(item.date).toLocaleTimeString('es-VE', { hour: '2-digit', minute: '2-digit', hour12: true });
                                    
                                    let displayDetails = item.description || '';
                                    if ((item.type === 'BET' || item.type === 'WIN') && item.track_name && item.track_name !== 'Hipódromo') {
                                         displayDetails = `<b style="color: #f8fafc; font-size: 0.9rem;">${item.track_name} - C${item.race_number}</b><br><span class="text-muted" style="font-size:0.8rem;">#${item.horse_number || '?'} ${item.horse_name || ''}</span>`;
                                    }

                                    return `
                                    <tr>
                                        <td class="text-muted" style="font-size: 0.8rem; white-space:nowrap;">${timeStr}</td>
                                        <td>
                                            <div style="display:flex; align-items:center; gap:10px;">
                                                <div style="width: 32px; height: 32px; border-radius: 6px; background: rgba(255,255,255,0.05); display: flex; align-items: center; justify-content: center; flex-shrink: 0;">
                                                    <i class="fas ${icon}" style="color:${colorClass}; font-size: 0.9rem;"></i>
                                                </div>
                                                <div>
                                                    <div style="font-size:0.7rem; font-weight:700; color:${colorClass}; margin-bottom: 2px;">${title}</div>
                                                    <div style="line-height: 1.3;">${displayDetails}</div>
                                                </div>
                                            </div>
                                        </td>
                                        <td class="text-right font-mono" style="font-weight:700; font-size:1.05rem; color:${sign === '+' ? '#10b981' : '#f8fafc'};">
                                            ${sign}$${item.amountUsd.toFixed(2)}
                                        </td>
                                    </tr>
                                    `;
                                }).join('')}
                            </tbody>
                        </table>
                    </div>
                </div>
                `;
            });

            contentDiv.innerHTML = html;

            contentDiv.querySelectorAll('.hist-tree-header').forEach(header => {
                header.onclick = (e) => {
                    const child = header.nextElementSibling;
                    const icon = header.querySelector('.fa-chevron-right, .fa-chevron-down');
                    
                    if (child.classList.contains('open')) {
                        child.classList.remove('open');
                        header.classList.remove('active');
                        if (icon) { icon.classList.remove('fa-chevron-down'); icon.classList.add('fa-chevron-right'); }
                    } else {
                        child.classList.add('open');
                        header.classList.add('active');
                        if (icon) { icon.classList.remove('fa-chevron-right'); icon.classList.add('fa-chevron-down'); }
                    }
                };
            });

        } catch (error) {
            contentDiv.innerHTML = `<div class="text-center text-danger" style="padding: 30px;">Error cargando el historial de transacciones.</div>`;
        }
    };

    // =========================================================================
    // 💰 MODAL: CAJA Y POLÍTICAS DE RIESGO
    // =========================================================================
    const openBalanceModal = (user, reloadCallback) => {
        const modal = document.createElement('div');
        modal.className = 'tabler-modal-overlay';
        
        const currentLimit = user.max_bet_limit !== null ? parseFloat(user.max_bet_limit).toFixed(2) : '';
        const currentBetsLimit = user.max_bets_per_race !== null ? user.max_bets_per_race : '';
        const currentPayUsd = user.max_payout_usd !== null ? parseFloat(user.max_payout_usd).toFixed(2) : '';
        const currentPayVes = user.max_payout_ves !== null ? parseFloat(user.max_payout_ves).toFixed(2) : '';

        modal.innerHTML = `
            <div class="tabler-modal-content">
                <div class="tabler-modal-header">
                    <h3><i class="fas fa-wallet text-green-400"></i> Gestión de Caja y Límites</h3>
                    <p style="color: #94a3b8; font-size: 0.95rem; margin: 0;">Cliente: <b style="color: #f8fafc;">${user.alias || user.username}</b></p>
                </div>
                
                <div style="background: rgba(16, 185, 129, 0.1); border: 1px solid rgba(16, 185, 129, 0.2); border-radius: 8px; padding: 20px; text-align: center; margin-bottom: 1.5rem;">
                    <div style="font-size: 0.8rem; color: #34d399; text-transform: uppercase; font-weight: 700; margin-bottom: 5px;">Saldo Disponible</div>
                    <div class="font-mono" style="font-size: 2.5rem; color: #10b981; font-weight: 700; line-height: 1;">$${parseFloat(user.balance_usd).toFixed(2)}</div>
                </div>

                <!-- OPERAR CAJA -->
                <div style="background: #0f172a; padding: 20px; border-radius: 8px; border: 1px solid #334155; margin-bottom: 1.5rem;">
                    <h4 style="font-size: 1rem; margin: 0 0 15px 0; color: #f8fafc;"><i class="fas fa-exchange-alt text-blue-400"></i> Ajuste de Saldo Manual</h4>
                    <div class="form-grid">
                        <div class="form-group">
                            <label>Monto</label>
                            <input type="number" id="op-amount" class="tabler-input font-mono" placeholder="0.00" min="0.01" step="0.01" style="font-size: 1.1rem; font-weight: 700;">
                        </div>
                        <div class="form-group">
                            <label>Moneda</label>
                            <select id="op-currency" class="tabler-select">
                                <option value="USD">Dólar ($ USD)</option>
                                <option value="VES">Bolívar (Bs)</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group" style="margin-top: 1rem;">
                        <label>Tipo de Operación</label>
                        <select id="op-type" class="tabler-select" style="font-weight:bold; color: #D4AF37;">
                            <option value="CREDIT">📥 INGRESAR SALDO (+)</option>
                            <option value="DEBIT">📤 RETIRAR SALDO (-)</option>
                        </select>
                    </div>
                </div>

                <!-- POLÍTICAS DE RIESGO -->
                <div style="background: #0f172a; padding: 20px; border-radius: 8px; border: 1px solid #334155;">
                    <h4 style="font-size: 1rem; margin: 0 0 15px 0; color: #ef4444;"><i class="fas fa-shield-alt"></i> Control de Riesgo (Topes)</h4>
                    <div class="form-grid">
                        <div class="form-group">
                            <label>Max Apuesta ($)</label>
                            <input type="number" id="op-bet-limit" class="tabler-input" value="${currentLimit}" placeholder="Tope Global">
                        </div>
                        <div class="form-group">
                            <label>Apuestas x Carrera</label>
                            <input type="number" id="op-bets-race-limit" class="tabler-input" value="${currentBetsLimit}" placeholder="Tope Global">
                        </div>
                    </div>
                    <div class="form-grid" style="margin-top: 1rem;">
                        <div class="form-group">
                            <label>Max Premio Pagado ($)</label>
                            <input type="number" id="op-pay-usd" class="tabler-input" value="${currentPayUsd}" placeholder="Sin límite">
                        </div>
                        <div class="form-group">
                            <label>Max Premio Pagado (Bs)</label>
                            <input type="number" id="op-pay-ves" class="tabler-input" value="${currentPayVes}" placeholder="Sin límite">
                        </div>
                    </div>
                </div>

                <div class="tabler-modal-actions">
                    <button id="cancel-op" class="tabler-btn btn-secondary">Cancelar</button>
                    <button id="confirm-op" class="tabler-btn btn-success"><i class="fas fa-save"></i> Guardar Cambios</button>
                </div>
            </div>
        `;
        
        document.body.appendChild(modal);
        setTimeout(() => modal.classList.add('visible'), 10);

        modal.querySelector('#cancel-op').onclick = () => {
            modal.classList.remove('visible');
            setTimeout(() => modal.remove(), 200);
        };

        modal.querySelector('#confirm-op').onclick = async () => {
            const amountInput = modal.querySelector('#op-amount').value;
            const amount = amountInput ? parseFloat(amountInput) : 0;
            const currency = modal.querySelector('#op-currency').value;
            const type = modal.querySelector('#op-type').value;
            
            const limitVal = modal.querySelector('#op-bet-limit').value;
            const betsRaceVal = modal.querySelector('#op-bets-race-limit').value;
            const payUsdVal = modal.querySelector('#op-pay-usd').value;
            const payVesVal = modal.querySelector('#op-pay-ves').value;

            if(amount < 0) return Notification(notificationContainer, 'El monto no puede ser negativo', 'warning');

            const btn = modal.querySelector('#confirm-op');
            btn.disabled = true; btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Guardando...';

            try {
                if (amount > 0) {
                    let amountUSD = amount;
                    if (currency === 'VES') {
                        if (cashierState.exchangeRate <= 0) throw new Error('Tasa de cambio inválida.');
                        amountUSD = amount / cashierState.exchangeRate;
                    }
                    await api.post('/remate/users/balance', {
                        user_id: user.id, amount_usd: amountUSD, operation_type: type,
                        description: `Ajuste Operador: ${type === 'CREDIT' ? 'Ingreso' : 'Retiro'} (${currency} ${amount})`
                    });
                }

                await api.put(`/remate/users/${user.id}/limits`, { 
                    max_bet_limit: limitVal === '' ? null : parseFloat(limitVal),
                    max_bets_per_race: betsRaceVal === '' ? null : parseInt(betsRaceVal),
                    max_payout_usd: payUsdVal === '' ? null : parseFloat(payUsdVal),
                    max_payout_ves: payVesVal === '' ? null : parseFloat(payVesVal)
                });

                Notification(notificationContainer, 'Cliente actualizado.', 'success');
                modal.classList.remove('visible');
                setTimeout(() => modal.remove(), 200);
                if (reloadCallback) reloadCallback();
            } catch (e) {
                Notification(notificationContainer, e.message || 'Error de conexión', 'error');
                btn.disabled = false; btn.innerHTML = '<i class="fas fa-save"></i> Guardar Cambios';
            }
        };
    };

    // =========================================================================
    // ⚙️ VISTA: MIS REGLAS (HIPÓDROMOS, MANTEQUILLA, LOGROS)
    // =========================================================================
    const renderMyRules = async (container) => {
        container.innerHTML = `<div class="loader-container"><i class="fas fa-spinner fa-spin"></i><br>Cargando configuraciones...</div>`;
        
        try {
            const conf = await api.get('/configs/cashier');
            const data = Array.isArray(conf) ? conf[0] : (conf || {});
            
            let trackConfigs = data.track_configs || {};
            if (typeof trackConfigs === 'string') { try{ trackConfigs = JSON.parse(trackConfigs); }catch(e){} }
            
            let rinconadaRules = data.rinconada_rules || {};
            if (typeof rinconadaRules === 'string') { try{ rinconadaRules = JSON.parse(rinconadaRules); }catch(e){} }
            let valenciaRules = data.valencia_rules || {};
            if (typeof valenciaRules === 'string') { try{ valenciaRules = JSON.parse(valenciaRules); }catch(e){} }
            
            let operatorConds = data.horse_conditions || [];
            if (typeof operatorConds === 'string') { try{ operatorConds = JSON.parse(operatorConds); }catch(e){ operatorConds = [];} }

            // ⭐ NUEVO: Leer las escalas dinámicas de pujas (o inyectar por defecto si no existen)
            let bidScales = data.bid_scales || [{"min":0,"max":20,"step":5},{"min":20,"max":60,"step":10},{"min":60,"max":200,"step":20},{"min":200,"max":500,"step":50},{"min":500,"max":1200,"step":100},{"min":1200,"max":999999,"step":200}];
            if (typeof bidScales === 'string') { try{ bidScales = JSON.parse(bidScales); }catch(e){} }

            const tracksResponse = await api.get(`/remate/tracks?_t=${Date.now()}`);
            const tracksList = tracksResponse.tracks || tracksResponse;

            container.innerHTML = `
                <div class="tabler-card">
                    <div class="tabler-card-header"><h3 class="tabler-card-title"><i class="fas fa-eye text-blue-400"></i> Visibilidad de Hipódromos</h3></div>
                    <div class="tabler-card-body">
                        <p class="content-desc">Selecciona qué hipódromos pueden ver tus clientes y si tienen permitido jugar a Placé.</p>
                        
                        <div class="tabler-table-container" style="margin-bottom: 1.5rem;">
                            <table class="tabler-table">
                                <thead>
                                    <tr><th>Hipódromo</th><th class="text-center">Visible para clientes</th><th class="text-center">Permitir Apuesta Placé</th></tr>
                                </thead>
                                <tbody id="track-configs-body">
                                    ${tracksList.map(t => {
                                        const c = trackConfigs[t.id] || { visible: true, allow_place: true };
                                        return `
                                            <tr data-track-id="${t.id}">
                                                <td style="font-weight:600; color:#f8fafc;">${t.name}</td>
                                                <td class="text-center">
                                                    <input type="checkbox" class="track-vis-cb" ${c.visible !== false ? 'checked' : ''} style="width:18px;height:18px;accent-color:#10b981;">
                                                </td>
                                                <td class="text-center">
                                                    <input type="checkbox" class="track-plc-cb" ${c.allow_place !== false ? 'checked' : ''} style="width:18px;height:18px;accent-color:#3b82f6;">
                                                </td>
                                            </tr>
                                        `;
                                    }).join('')}
                                </tbody>
                            </table>
                        </div>

                        <h4 style="color: #f8fafc; margin-bottom: 1rem; padding-top: 1rem; border-top: 1px dashed #334155;"><i class="fas fa-globe text-yellow-400"></i> Reglas Generales</h4>
                        <div class="form-grid">
                            <div class="form-group">
                                <label>Mantequilla ($) - Apuestas WIN</label>
                                <input type="number" id="my-mant" class="tabler-input font-mono" step="0.1" value="${data.mantequilla || ''}" placeholder="Ej: 0.50">
                            </div>
                            <div class="form-group">
                                <label>Límite Global Venta (Max $)</label>
                                <input type="number" id="my-max-bet" class="tabler-input font-mono" value="${data.monto_maximo_ticket || ''}" placeholder="Ej: 200">
                            </div>
                        </div>
                        <div class="form-group" style="background: rgba(16, 185, 129, 0.05); padding: 15px; border-radius: 8px; border: 1px dashed #10b981; margin-top: 1rem;">
                            <label style="color: #10b981; cursor: pointer; display: flex; align-items: center; gap: 10px; font-size: 0.95rem; font-weight: 600;">
                                <input type="checkbox" id="my-hide-regular" style="width:18px; height:18px; accent-color: #10b981;" ${data.hide_regular_races ? 'checked' : ''}> 
                                Ocultar Carreras Normales de Hoy en la App
                            </label>
                            <small style="color:#94a3b8; display:block; margin-left:28px; margin-top:5px; text-transform:none;">Al activarlo, tus clientes solo verán los <b>Remates Anticipados</b> exclusivos para ti.</small>
                        </div>

                        <!-- ⭐ NUEVO: UI DE ESCALAS DE PUJA -->
                        <h4 style="color: #60a5fa; margin-bottom: 1rem; padding-top: 1.5rem; border-top: 1px dashed #334155;"><i class="fas fa-layer-group"></i> Escalas de Puja en Subasta</h4>
                        <p class="content-desc" style="margin-bottom:10px;">Define cuánto suma el botón del martillo (Salto) dependiendo del precio actual de la tabla (Min a Max).</p>
                        <div id="bid-scales-container"></div>
                        <button id="btn-add-bid-scale" class="tabler-btn btn-secondary" style="width:100%; margin-top:10px; border-style:dashed;">+ Agregar Escala de Puja</button>

                        <!-- Botón actualizado para reflejar que guarda ambas cosas -->
                        <button class="tabler-btn btn-primary" id="btn-save-my-config" style="width:100%; margin-top: 2rem;"><i class="fas fa-save"></i> Guardar Todo (Reglas y Escalas)</button>
                    </div>
                </div>

                <div class="tabler-card">
                    <div class="tabler-card-header"><h3 class="tabler-card-title"><i class="fas fa-flag text-yellow-500"></i> Reglas Nacionales (Rangos)</h3></div>
                    <div class="tabler-card-body">
                        <div class="form-grid" style="border-bottom: 1px solid #334155; padding-bottom: 15px; margin-bottom: 15px;">
                            <div class="form-group"><label style="color:#D4AF37;">Rinconada - Valor Ganador (Base Bs)</label><input type="number" id="rin-unit" class="tabler-input font-mono" value="${rinconadaRules.unit_cost || ''}" placeholder="Ej: 100"></div>
                            <div class="form-group"><label style="color:#D4AF37;">Rinconada - Tope Máximo (Bs)</label><input type="number" id="rin-cap" class="tabler-input font-mono" value="${rinconadaRules.cap || ''}" placeholder="Ej: 700"></div>
                        </div>
                        <div class="form-grid">
                            <div class="form-group"><label style="color:#3b82f6;">Valencia - Valor Ganador (Base Bs)</label><input type="number" id="val-unit" class="tabler-input font-mono" value="${valenciaRules.unit_cost || ''}" placeholder="Ej: 100"></div>
                            <div class="form-group"><label style="color:#3b82f6;">Valencia - Tope Máximo (Bs)</label><input type="number" id="val-cap" class="tabler-input font-mono" value="${valenciaRules.cap || ''}" placeholder="Ej: 700"></div>
                        </div>

                        <div style="margin-top:1.5rem; font-weight:600; font-size:0.8rem; color:#94a3b8; margin-bottom:10px; text-transform:uppercase;">Rangos de Pago Rinconada</div>
                        <div id="ranges-container-rin"></div>
                        <button id="btn-add-range-rin" class="tabler-btn btn-secondary" style="width:100%; margin-top:10px; border-style:dashed;">+ Agregar Rango Rinconada</button>
                        
                        <div style="margin-top:1.5rem; font-weight:600; font-size:0.8rem; color:#94a3b8; margin-bottom:10px; text-transform:uppercase;">Rangos de Pago Valencia</div>
                        <div id="ranges-container-val"></div>
                        <button id="btn-add-range-val" class="tabler-btn btn-secondary" style="width:100%; margin-top:10px; border-style:dashed;">+ Agregar Rango Valencia</button>
                        
                        <div style="display:flex; gap:10px; margin-top: 1.5rem;">
                            <button class="tabler-btn btn-success" id="btn-save-rin" style="flex:1;"><i class="fas fa-save"></i> Guardar Rinconada</button>
                            <button class="tabler-btn btn-primary" id="btn-save-val" style="flex:1; background:#3b82f6; border-color:#3b82f6;"><i class="fas fa-save"></i> Guardar Valencia</button>
                        </div>
                    </div>
                </div>

                <div class="tabler-card">
                    <div class="tabler-card-header"><h3 class="tabler-card-title"><i class="fas fa-horse-head text-purple-400"></i> Logros y Empates Condicionados</h3></div>
                    <div class="tabler-card-body">
                        <p class="content-desc">Asigna un logro específico a un caballo. El pago se aislará solo para tus clientes.</p>
                        <div class="form-grid">
                            <div class="form-group"><label>Hipódromo</label><select id="cond-track" class="tabler-select"><option>Cargando...</option></select></div>
                            <div class="form-group"><label>Carrera</label><select id="cond-race" class="tabler-select"><option>Selecciona Hipódromo</option></select></div>
                        </div>
                        <div id="cond-horses-list" style="display:none; max-height: 500px; overflow-y:auto; border-top: 1px solid #334155; padding-top: 1.25rem; margin-top:1rem; padding-right: 10px;"></div>
                    </div>
                </div>
            `;

            const addRangeToDOM = (containerId, d={min:'',max:'',type:'FIJO',value:''}) => {
                const div = document.createElement('div');
                div.className = 'range-row'; // ⭐ FIX: Agregamos clase identificadora estricta
                div.style.display = 'flex'; div.style.gap = '10px'; div.style.marginBottom = '10px'; div.style.flexWrap = 'wrap';
                div.innerHTML=`
                    <div style="flex: 1; min-width:80px;"><input class="tabler-input font-mono r-min" type="number" placeholder="Min" value="${d.min!==undefined?d.min:''}"></div>
                    <div style="flex: 1; min-width:80px;"><input class="tabler-input font-mono r-max" type="number" placeholder="Max" value="${d.max!==undefined?d.max:''}"></div>
                    <div style="flex: 1.5; min-width:100px;">
                        <select class="tabler-select r-type">
                            <option value="FIJO" ${d.type==='FIJO'?'selected':''}>FIJO</option>
                            <option value="SUMAR" ${d.type==='SUMAR'?'selected':''}>SUMA</option>
                        </select>
                    </div>
                    <div style="flex: 1.5; min-width:100px;"><input class="tabler-input font-mono r-val" type="number" placeholder="Valor" value="${d.value!==undefined?d.value:''}"></div>
                    <button class="tabler-btn btn-danger" style="padding:10px 15px;" onclick="this.parentElement.remove()"><i class="fas fa-times"></i></button>
                `;
                document.getElementById(containerId).appendChild(div);
            };

            // ⭐ NUEVO: Helper para inyectar filas de escalas de puja en el DOM
            const addBidScaleToDOM = (d={min:0, max:0, step:0}) => {
                const div = document.createElement('div');
                div.style.display = 'flex'; div.style.gap = '10px'; div.style.marginBottom = '10px'; div.style.flexWrap = 'wrap';
                div.innerHTML=`
                    <div class="form-group" style="flex:1;min-width:80px;margin-bottom:0;"><label style="font-size:0.65rem;">Precio Min ($)</label><input class="tabler-input font-mono s-min" type="number" value="${d.min}"></div>
                    <div class="form-group" style="flex:1;min-width:80px;margin-bottom:0;"><label style="font-size:0.65rem;">Precio Max ($)</label><input class="tabler-input font-mono s-max" type="number" value="${d.max}"></div>
                    <div class="form-group" style="flex:1;min-width:80px;margin-bottom:0;"><label style="font-size:0.65rem;color:#10b981;">Salto / Suma</label><input class="tabler-input font-mono s-step" type="number" value="${d.step}" style="border-color:#10b981;"></div>
                    <button class="tabler-btn btn-danger" style="padding:10px; margin-top:20px;" onclick="this.parentElement.remove()"><i class="fas fa-times"></i></button>
                `;
                container.querySelector('#bid-scales-container').appendChild(div);
            };

            if(rinconadaRules.ranges && Array.isArray(rinconadaRules.ranges)) rinconadaRules.ranges.forEach(r => addRangeToDOM('ranges-container-rin', r));
            if(valenciaRules.ranges && Array.isArray(valenciaRules.ranges)) valenciaRules.ranges.forEach(r => addRangeToDOM('ranges-container-val', r));
            
            // ⭐ NUEVO: Generar filas iniciales de las escalas de puja
            if(bidScales) bidScales.forEach(s => addBidScaleToDOM(s));

            container.querySelector('#btn-add-range-rin').onclick = () => addRangeToDOM('ranges-container-rin');
            container.querySelector('#btn-add-range-val').onclick = () => addRangeToDOM('ranges-container-val');
            
            // ⭐ NUEVO: Botón de agregar fila de escala
            container.querySelector('#btn-add-bid-scale').onclick = () => addBidScaleToDOM();

            const saveNationalRules = async (btn, type, unitId, capId, containerId) => {
                const ranges = [];
                // ⭐ FIX: Buscar estrictamente por la clase .range-row para no iterar sobre divs anidados
                document.querySelectorAll(`#${containerId} .range-row`).forEach(r => {
                    const minEl = r.querySelector('.r-min');
                    if(!minEl) return;
                    const min = parseFloat(minEl.value);
                    const max = parseFloat(r.querySelector('.r-max').value);
                    const rtype = r.querySelector('.r-type').value;
                    const value = parseFloat(r.querySelector('.r-val').value);
                    if(!isNaN(min) && !isNaN(max) && !isNaN(value)) ranges.push({ min, max, type: rtype, value });
                });

                const payload = {
                    unit_cost: parseFloat(document.getElementById(unitId).value) || 0,
                    cap: parseFloat(document.getElementById(capId).value) || 0,
                    ranges: ranges
                };

                const origText = btn.innerHTML;
                btn.disabled = true; btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i>';
                try {
                    await api.post('/remate/operator/rules', { type: type, data: payload });
                    Notification(notificationContainer, `Reglas ${type} guardadas.`, 'success');
                } catch(e) { Notification(notificationContainer, 'Error al guardar.', 'error'); } 
                finally { btn.disabled = false; btn.innerHTML = origText; }
            };

            container.querySelector('#btn-save-rin').onclick = (e) => saveNationalRules(e.currentTarget, 'rinconada', 'rin-unit', 'rin-cap', 'ranges-container-rin');
            container.querySelector('#btn-save-val').onclick = (e) => saveNationalRules(e.currentTarget, 'valencia', 'val-unit', 'val-cap', 'ranges-container-val');

            container.querySelector('#btn-save-my-config').onclick = async (e) => {
                const btn = e.currentTarget;
                const m = container.querySelector('#my-mant').value;
                const limit = container.querySelector('#my-max-bet').value;
                const hideRegular = container.querySelector('#my-hide-regular').checked; 
                
                const newTrackConfigs = {};
                container.querySelectorAll('#track-configs-body tr').forEach(tr => {
                    const tId = tr.dataset.trackId;
                    const visible = tr.querySelector('.track-vis-cb').checked;
                    const allow_place = tr.querySelector('.track-plc-cb').checked;
                    newTrackConfigs[tId] = { visible, allow_place };
                });

                // ⭐ NUEVO: Extraer escalas de puja ingresadas por el operador en el DOM
                const newBidScales = [];
                container.querySelectorAll('#bid-scales-container > div').forEach(r => {
                    const min = parseFloat(r.querySelector('.s-min').value);
                    const max = parseFloat(r.querySelector('.s-max').value);
                    const step = parseFloat(r.querySelector('.s-step').value);
                    if(!isNaN(min) && !isNaN(max) && !isNaN(step)) newBidScales.push({ min, max, step });
                });

                const origText = btn.innerHTML;
                btn.disabled = true; btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i>';
                try {
                    await api.post('/remate/operator/rules', {
                        type: 'general',
                        data: { 
                            mantequilla: m ? parseFloat(m) : 0, 
                            monto_maximo_ticket: limit ? parseFloat(limit) : 0,
                            hide_regular_races: hideRegular,
                            track_configs: newTrackConfigs,
                            bid_scales: newBidScales // ⭐ SE ENVÍAN AL BACKEND
                        }
                    });
                    Notification(notificationContainer, 'Configuración actualizada.', 'success');
                } catch(e) { Notification(notificationContainer, 'Error al guardar.', 'error'); } 
                finally { btn.disabled = false; btn.innerHTML = origText; }
            };

            const trackSel = container.querySelector('#cond-track');
            const raceSel = container.querySelector('#cond-race');
            const horseList = container.querySelector('#cond-horses-list');

            trackSel.innerHTML = '<option value="">-- Selecciona Hipódromo --</option>' + tracksList.map(t => `<option value="${t.id}">${t.name}</option>`).join('');

            trackSel.onchange = async () => {
                raceSel.innerHTML = '<option>Cargando...</option>'; horseList.style.display = 'none';
                const tId = trackSel.value;
                if(!tId) return;
                try {
                    const races = await api.get(`/remate/races/${tId}`);
                    raceSel.innerHTML = '<option value="">-- Selecciona Carrera --</option>' + races.filter(r => r.status === 'open' || r.status === 'scheduled').map(r => `<option value="${r.id}" data-track="${r.track_name}">Carrera ${r.race_number} - ${r.name}</option>`).join('');
                } catch(e) { raceSel.innerHTML = '<option>Error</option>'; }
            };

            raceSel.onchange = async () => {
                const rId = raceSel.value;
                if(!rId) return horseList.style.display = 'none';

                horseList.innerHTML = '<div class="loader-container"><i class="fas fa-spinner fa-spin"></i></div>';
                horseList.style.display = 'block';

                try {
                    const horsesData = await api.get(`/remate/horses/${rId}`);
                    const horses = horsesData.horses || [];
                    
                    if(horses.length === 0) return horseList.innerHTML = '<p class="text-muted">No hay caballos.</p>';

                    let hHtml = `
                        <div style="background: rgba(59, 130, 246, 0.1); padding: 12px; border-radius: 8px; margin-bottom: 1.5rem; font-size: 0.85rem; color: #cbd5e1; border: 1px solid rgba(59, 130, 246, 0.2);">
                            <i class="fas fa-info-circle text-blue-400"></i> Ingresa <b>Arriesga</b> y <b>Gana</b> para un logro fijo, o presiona <b>🚫 Invalidar</b> para bloquear el caballo y asignar un sustituto en caso de que gane.
                        </div>
                    `;

                    horses.forEach(h => {
                        // Si el caballo está retirado oficialmente por la casa, no lo mostramos (a menos que esté invalidado por nosotros)
                        if (h.is_withdrawn && !h.is_invalidated) return;
                        
                        let savedMult = '';
                        let isInvalidated = false;
                        let subId = '';

                        const match = operatorConds.find(c => String(c.race_id) === String(rId) && String(c.horse_id) === String(h.id));
                        if (match) {
                            savedMult = match.multiplier || '';
                            isInvalidated = match.is_invalidated === true;
                            subId = match.substitute_id || '';
                        }

                        // Construimos la lista de caballos sustitutos
                        let substituteOptions = `<option value="">-- Sin Sustituto --</option>`;
                        horses.forEach(subH => {
                            if (subH.id !== h.id && !subH.is_withdrawn) {
                                substituteOptions += `<option value="${subH.id}" ${String(subH.id) === String(subId) ? 'selected' : ''}>Pagar a: #${subH.horse_number} ${subH.name}</option>`;
                            }
                        });

                        // Construimos la tarjeta del caballo
                        hHtml += `
                            <div class="horse-card" data-hid="${h.id}" style="background: ${isInvalidated ? 'rgba(239,68,68,0.1)' : '#0f172a'}; padding: 1.25rem; border-radius: 8px; border: 1px solid ${isInvalidated ? '#ef4444' : '#334155'}; margin-bottom: 1rem; opacity: ${isInvalidated ? '0.8' : '1'}; transition: all 0.3s;">
                                
                                <div style="font-weight:600; font-size:1.05rem; color:#f8fafc; margin-bottom:1rem; display:flex; justify-content:space-between; align-items:center;">
                                    <div><span style="color: #D4AF37;">#${h.horse_number}</span> <span style="${isInvalidated ? 'text-decoration:line-through; color:#ef4444;' : ''}">${h.name}</span></div>
                                    <div>
                                        <button class="tabler-btn ${isInvalidated ? 'btn-success' : 'btn-danger'}" style="padding:4px 8px; font-size:0.8rem;" onclick="window.toggleHorseInvalidation(${rId}, ${h.id}, ${!isInvalidated}, this)">
                                            ${isInvalidated ? '<i class="fas fa-check"></i> Restaurar' : '<i class="fas fa-ban"></i> Invalidar'}
                                        </button>
                                    </div>
                                </div>
                                
                                <!-- Sección de Logro Condicionado (Se oculta si el caballo está invalidado) -->
                                <div class="form-grid" style="gap: 1rem; display: ${isInvalidated ? 'none' : 'grid'};">
                                    <div class="form-group" style="margin-bottom:0;"><label>Arriesga</label><input type="number" class="tabler-input font-mono cond-arr" placeholder="10"></div>
                                    <div class="form-group" style="margin-bottom:0;"><label>Gana</label><input type="number" class="tabler-input font-mono cond-gan" placeholder="4"></div>
                                </div>
                                
                                <!-- Sección de Caballo Sustituto (Se muestra SOLO si el caballo está invalidado) -->
                                <div class="form-group" style="margin-bottom:0; margin-top:10px; display: ${isInvalidated ? 'block' : 'none'};">
                                    <label style="color:#ef4444; font-weight:bold; margin-bottom:5px; display:block;">Si este caballo gana, transferir premio a:</label>
                                    <select class="tabler-select cond-substitute">${substituteOptions}</select>
                                </div>

                                <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 1rem; padding-top: 1rem; border-top: 1px dashed #334155;">
                                    <div style="color: ${isInvalidated ? '#ef4444' : '#10b981'}; font-weight:600; font-size: 0.85rem;">
                                        ${isInvalidated ? 'Estado: INVALIDADO 🚫' : `Factor: \${savedMult ? savedMult+'x' : 'Ninguno'}`}
                                    </div>
                                    <button class="tabler-btn btn-success btn-save-logro"><i class="fas fa-save"></i> Fíjar</button>
                                </div>
                            </div>
                        `;
                    });

                    horseList.innerHTML = hHtml;

                    // Evento para Guardar (Sirve tanto para Logros como para Sustitutos)
                    horseList.querySelectorAll('.btn-save-logro').forEach(btn => {
                        btn.onclick = async (e) => {
                            const card = e.currentTarget.closest('.horse-card');
                            const hId = card.dataset.hid;
                            
                            const isInvalidatedEl = operatorConds.find(c => String(c.race_id) === String(rId) && String(c.horse_id) === String(hId))?.is_invalidated === true;
                            
                            const arr = parseFloat(card.querySelector('.cond-arr').value);
                            const gan = parseFloat(card.querySelector('.cond-gan').value);
                            const subSelect = card.querySelector('.cond-substitute');
                            const subId = subSelect ? subSelect.value : null;

                            let finalMult = null;
                            if(arr > 0 && gan > 0) finalMult = (gan / arr).toFixed(6);

                            const origHTML = btn.innerHTML;
                            btn.disabled = true; btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i>';

                            try {
                                await api.post('/remate/operator/rules', {
                                    type: 'horse_condition',
                                    data: { race_id: rId, horse_id: hId, multiplier: finalMult, is_invalidated: isInvalidatedEl, substitute_id: subId }
                                });
                                
                                // Actualizamos la memoria local del operador
                                const matchIdx = operatorConds.findIndex(c => String(c.race_id) === String(rId) && String(c.horse_id) === String(hId));
                                const newCond = { race_id: rId, horse_id: hId, multiplier: finalMult, is_invalidated: isInvalidatedEl, substitute_id: subId };
                                if (matchIdx !== -1) operatorConds[matchIdx] = newCond;
                                else operatorConds.push(newCond);

                                btn.innerHTML = '<i class="fas fa-check"></i>';
                                setTimeout(() => { btn.innerHTML = origHTML; btn.disabled = false; }, 1500);
                            } catch(err) {
                                Notification(notificationContainer, 'Error al guardar', 'error');
                                btn.innerHTML = origHTML; btn.disabled = false;
                            }
                        };
                    });
                    
                    // Función Global Inyectada para el Botón "🚫 Invalidar / ✅ Restaurar"
                    window.toggleHorseInvalidation = async (rId, hId, isInvalid, btnElement) => {
                        const origHTML = btnElement.innerHTML;
                        btnElement.disabled = true; btnElement.innerHTML = '...';
                        
                        try {
                            const existingCond = operatorConds.find(c => String(c.race_id) === String(rId) && String(c.horse_id) === String(hId));
                            const currentMult = existingCond ? existingCond.multiplier : null;
                            const currentSub = existingCond ? existingCond.substitute_id : null;

                            await api.post('/remate/operator/rules', {
                                type: 'horse_condition',
                                data: { race_id: rId, horse_id: hId, multiplier: currentMult, is_invalidated: isInvalid, substitute_id: currentSub }
                            });
                            
                            const matchIdx = operatorConds.findIndex(c => String(c.race_id) === String(rId) && String(c.horse_id) === String(hId));
                            if (matchIdx !== -1) operatorConds[matchIdx].is_invalidated = isInvalid;
                            else operatorConds.push({ race_id: rId, horse_id: hId, multiplier: currentMult, is_invalidated: isInvalid, substitute_id: currentSub });
                            
                            // Recargamos la vista para que se re-dibuje el CSS de invalidación
                            raceSel.dispatchEvent(new Event('change'));
                            Notification(notificationContainer, isInvalid ? 'Caballo invalidado.' : 'Caballo restaurado.', 'success');
                        } catch(e) {
                            Notification(notificationContainer, 'Error al cambiar estado.', 'error');
                            btnElement.disabled = false; btnElement.innerHTML = origHTML;
                        }
                    };

                } catch(e) { horseList.innerHTML = '<p class="text-danger">Error de carga</p>'; }
            };

        } catch(e) {
            container.innerHTML = `<div class="text-center text-danger py-5">Error conectando con el servidor.</div>`;
        }
    };

    // =========================================================================
    // 👑 VISTA: MIS SALAS VIP (CREACIÓN B2B Y PRECIOS BASE AISLADOS)
    // =========================================================================
    const renderMyVipRooms = async (container) => {
        let vipAutoRefresh = null;
        let allVipRooms = []; 
        let loadedTracks = []; // ⭐ Almacenará los hipódromos cargados globalmente

        container.innerHTML = `
            <div id="vip-dashboard-view" class="tabler-card">
                <div class="tabler-card-header">
                    <h3 class="tabler-card-title"><i class="fas fa-crown text-purple-400"></i> Mis Salas VIP</h3>
                    <button id="btn-show-creator" class="tabler-btn btn-primary"><i class="fas fa-plus"></i> Nueva Sala</button>
                </div>
                
                <div class="tabler-card-body">
                    <div class="filter-grid" style="margin-bottom: 1.5rem;">
                        <!-- ⭐ NUEVO: Filtros con la fecha de hoy por defecto -->
                        <div class="filter-group"><label>Desde</label><input type="date" id="vip-filter-start" class="tabler-input" value="${moment().tz(VENEZUELA_TIMEZONE).format('YYYY-MM-DD')}"></div>
                        <div class="filter-group"><label>Hasta</label><input type="date" id="vip-filter-end" class="tabler-input" value="${moment().tz(VENEZUELA_TIMEZONE).format('YYYY-MM-DD')}"></div>
                        
                        <!-- ⭐ NUEVO: Selector de Hipódromos con búsqueda (Datalist) -->
                        <div class="filter-group">
                            <label>Hipódromo</label>
                            <input list="vip-filter-track-list" id="vip-filter-track" class="tabler-input" placeholder="Todos (Buscar...)">
                            <datalist id="vip-filter-track-list"></datalist>
                        </div>
                        <button id="btn-filter-vip" class="tabler-btn btn-secondary" style="height: 38px;"><i class="fas fa-search"></i> Filtrar</button>
                    </div>

                    <div id="active-rooms-grid" class="widget-grid" style="gap: 1.5rem;">
                        <div class="loader-container"><i class="fas fa-spinner fa-spin"></i> Cargando...</div>
                    </div>
                </div>
            </div>

            <div id="vip-editor-view" class="tabler-card hidden">
                <div class="tabler-card-header">
                    <h3 class="tabler-card-title"><i class="fas fa-cog text-muted"></i> Configuración de Sala</h3>
                    <button id="btn-back-to-dash" class="tabler-btn btn-secondary"><i class="fas fa-arrow-left"></i> Volver</button>
                </div>
                
                <div class="tabler-card-body">
                    <div class="form-grid">
                        <!-- ⭐ NUEVO: Buscador de Hipódromos Inteligente al Crear Sala -->
                        <div class="form-group">
                            <label>Hipódromo</label>
                            <input list="vip-track-list" id="vip-track-input" class="tabler-input" placeholder="Escribe para buscar...">
                            <datalist id="vip-track-list"></datalist>
                            <input type="hidden" id="vip-track">
                        </div>
                        <div class="form-group"><label>Carrera</label><select id="vip-race" class="tabler-select" disabled><option>Selecciona Hipódromo</option></select></div>
                    </div>

                    <div id="vip-workspace" class="hidden" style="border-top: 1px dashed #334155; padding-top: 1.5rem; margin-top: 1rem;">
                        <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:1rem;">
                            <h4 style="margin:0; color:#60a5fa;"><i class="fas fa-door-closed"></i> Estado de la Sala</h4>
                            <span id="vip-status-badge" class="tabler-badge badge-gray">No Creada</span>
                        </div>

                        <div style="background: rgba(255,255,255,0.02); padding: 1.25rem; border-radius: 8px; border: 1px solid #334155; margin-bottom: 1.5rem;">
                            
                            <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:0.5rem;">
                                <label style="color:#f8fafc; font-weight:600; margin:0;"><i class="fas fa-user-check text-success"></i> Clientes Invitados</label>
                                <label style="color:#60a5fa; font-size:0.85rem; cursor:pointer; display:flex; align-items:center; gap:5px; font-weight:600;">
                                    <input type="checkbox" id="vip-select-all-cb" style="width:16px; height:16px; accent-color: #3b82f6;"> Marcar Todos
                                </label>
                            </div>
                            
                            <div id="vip-clients-list" style="max-height: 200px; overflow-y:auto; background: #0f172a; border: 1px solid #334155; padding: 10px; border-radius: 6px;">
                                ${cashierState.myClients.map(c => `
                                    <label style="display:flex; align-items:center; gap:10px; padding:8px 5px; border-bottom:1px solid #334155; cursor:pointer;">
                                        <input type="checkbox" class="vip-client-cb" value="${c.id}" style="width:16px; height:16px; accent-color: #3b82f6;">
                                        <span style="color:#cbd5e1; font-size:0.9rem;">${c.alias || c.username}</span>
                                    </label>
                                `).join('')}
                            </div>
                            
                            <div style="display:flex; gap:10px; margin-top:1rem; flex-wrap:wrap;">
                                <button id="btn-save-vip-room" class="tabler-btn btn-primary" style="flex:1;"><i class="fas fa-lock"></i> Crear Sala VIP</button>
                                <button id="btn-update-vip-users" class="tabler-btn btn-success hidden" style="flex:1;"><i class="fas fa-user-plus"></i> Guardar Invitados</button>
                            </div>
                        </div>

                        <div id="vip-prices-container" class="hidden">
                            <div style="margin-bottom: 1.5rem; padding: 1.25rem; background: rgba(59, 130, 246, 0.05); border-radius: 8px; border: 1px solid rgba(59, 130, 246, 0.2);">
                                <h4 style="color:#60a5fa; margin-top:0; margin-bottom:1rem;"><i class="fas fa-cogs"></i> Cronómetro y Pote Extra</h4>
                                <div class="form-grid" style="margin-bottom:0;">
                                    <div class="form-group" style="margin-bottom:0;"><label>Pote Extra ($)</label><input type="number" id="vip-manual-pote" class="tabler-input font-mono" placeholder="0"></div>
                                    <div class="form-group" style="margin-bottom:0;"><label>Duración (Min)</label><input type="number" id="vip-remate-duration" class="tabler-input font-mono" placeholder="0 = Infinito"></div>
                                    <div class="form-group" style="margin-bottom:0;"><label>Cierre x MTP</label><input type="number" id="vip-close-before" class="tabler-input font-mono" placeholder="0"></div>
                                </div>
                                <button id="btn-save-vip-config" class="tabler-btn btn-secondary" style="width:100%; margin-top: 1rem;"><i class="fas fa-save"></i> Aplicar</button>
                            </div>

                            <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:1rem;">
                                <h4 style="color:#10b981; margin:0;"><i class="fas fa-gavel"></i> Monitor de Subasta</h4>
                                <span id="live-pote-display" style="font-family:monospace; font-weight:700; font-size:1.2rem; color:#D4AF37;">Pote: $0.00</span>
                            </div>
                            
                            <div class="tabler-table-container">
                                <table class="tabler-table">
                                    <thead><tr><th class="text-center">#</th><th>Caballo</th><th>Puja Actual ($)</th><th class="text-center">Acción</th></tr></thead>
                                    <tbody id="vip-horses-body"></tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;

        const viewDashboard = container.querySelector('#vip-dashboard-view');
        const viewEditor = container.querySelector('#vip-editor-view');
        
        // ⭐ Instancias Datalist y UI Inputs
        const trackFilterInput = container.querySelector('#vip-filter-track');
        const trackFilterList = container.querySelector('#vip-filter-track-list');
        const trackInput = container.querySelector('#vip-track-input');
        const trackDatalist = container.querySelector('#vip-track-list');
        const trackIdHidden = container.querySelector('#vip-track');
        
        const raceSel = container.querySelector('#vip-race');
        const workspace = container.querySelector('#vip-workspace');
        const statusBadge = container.querySelector('#vip-status-badge');
        const pricesContainer = container.querySelector('#vip-prices-container');
        const horsesBody = container.querySelector('#vip-horses-body');
        const btnSaveRoom = container.querySelector('#btn-save-vip-room');
        const btnUpdateUsers = container.querySelector('#btn-update-vip-users');
        const selectAllCb = container.querySelector('#vip-select-all-cb'); 
        
        let currentRoomId = null;

        if (selectAllCb) {
            selectAllCb.onchange = (e) => {
                const isChecked = e.target.checked;
                container.querySelectorAll('.vip-client-cb').forEach(cb => cb.checked = isChecked);
            };
        }

        container.querySelectorAll('.vip-client-cb').forEach(cb => {
            cb.onchange = () => {
                if (selectAllCb) {
                    const allCheckboxes = Array.from(container.querySelectorAll('.vip-client-cb'));
                    selectAllCb.checked = allCheckboxes.length > 0 && allCheckboxes.every(c => c.checked);
                }
            };
        });

        const applyVipFilters = () => {
            const startStr = container.querySelector('#vip-filter-start').value;
            const endStr = container.querySelector('#vip-filter-end').value;
            const trackVal = trackFilterInput.value.trim().toLowerCase(); // Búsqueda tecleada
            const grid = container.querySelector('#active-rooms-grid');

            let filtered = allVipRooms || [];

            if (startStr) {
                const startMom = moment.tz(startStr + " 00:00:00", VENEZUELA_TIMEZONE);
                filtered = filtered.filter(r => r.start_time ? moment(r.start_time).tz(VENEZUELA_TIMEZONE).isSameOrAfter(startMom) : true);
            }
            if (endStr) {
                const endMom = moment.tz(endStr + " 23:59:59", VENEZUELA_TIMEZONE);
                filtered = filtered.filter(r => r.start_time ? moment(r.start_time).tz(VENEZUELA_TIMEZONE).isSameOrBefore(endMom) : true);
            }
            if (trackVal !== '' && trackVal !== 'todos') {
                filtered = filtered.filter(r => r && r.track_name && r.track_name.toLowerCase().includes(trackVal));
            }

            if (filtered.length === 0) {
                grid.innerHTML = '<div style="grid-column: 1 / -1; text-align:center; padding:30px; color:#94a3b8;">No se encontraron salas VIP con estos filtros.</div>';
                return;
            }

            grid.innerHTML = filtered.map(r => {
                const dateStr = r.start_time ? moment(r.start_time).tz(VENEZUELA_TIMEZONE).format('DD MMM - hh:mm A') : 'N/A';
                return `
                <div class="widget-box" style="border-left: 4px solid #8b5cf6; cursor: pointer;" onclick="window.editVipRoom(${r.track_id}, ${r.race_id})">
                    <div style="font-size:0.75rem; color:#8b5cf6; font-weight:700; margin-bottom:5px;">SALA PRIVADA ABIERTA</div>
                    <h3 style="font-size:1.15rem; margin:0 0 5px 0; color:#f8fafc;">${r.track_name || 'Desconocido'}</h3>
                    <p style="margin:0 0 10px 0; color:#94a3b8; font-size:0.85rem;">Carrera ${r.race_number || 0} <br>${dateStr}</p>
                    <div style="display:flex; justify-content:space-between; width:100%; border-top:1px solid #334155; padding-top:10px;">
                        <span style="font-size:0.8rem; color:#cbd5e1;"><i class="fas fa-users"></i> ${r.allowed_users ? r.allowed_users.length : 0}</span>
                        <span style="color:#D4AF37; font-weight:700; font-family:monospace;">$${parseFloat(r.total_pujas || 0).toFixed(2)}</span>
                    </div>
                </div>
                `;
            }).join('');
        };

        const loadDashboardRooms = async () => {
            const grid = container.querySelector('#active-rooms-grid');
            grid.innerHTML = '<div class="loader-container"><i class="fas fa-spinner fa-spin"></i></div>';
            try {
                allVipRooms = await api.get('/remate/operator/my-vip-rooms');
                const uniqueTracks = [...new Set(allVipRooms.map(r => r.track_name))];
                // Llenar el datalist del filtro con las opciones disponibles
                trackFilterList.innerHTML = uniqueTracks.map(t => `<option value="${t}">`).join('');

                applyVipFilters(); 
            } catch(e) { grid.innerHTML = '<div class="text-danger text-center">Error cargando salas.</div>'; }
        };

        container.querySelector('#btn-filter-vip').onclick = applyVipFilters;
        await loadDashboardRooms();

        container.querySelector('#btn-show-creator').onclick = async () => {
            viewDashboard.classList.add('hidden'); viewEditor.classList.remove('hidden');
            trackInput.value = '';
            trackIdHidden.value = '';
            raceSel.innerHTML = '<option>Selecciona Hipódromo</option>';
            raceSel.disabled = true;
            workspace.classList.add('hidden');
            
            try {
                const tracksResponse = await api.get(`/tracks?_t=${Date.now()}`);
                loadedTracks = tracksResponse.tracks || tracksResponse;
                // Poblar el datalist interactivo con opciones globales
                trackDatalist.innerHTML = loadedTracks.map(t => `<option value="${t.name}">`).join('');
            } catch(e) {}
        };

        const stopAutoRefresh = () => { if(vipAutoRefresh) { clearInterval(vipAutoRefresh); vipAutoRefresh = null; } };

        container.querySelector('#btn-back-to-dash').onclick = () => {
            stopAutoRefresh();
            viewEditor.classList.add('hidden'); viewDashboard.classList.remove('hidden');
            loadDashboardRooms();
        };

        window.editVipRoom = async (tId, rId) => {
            container.querySelector('#btn-show-creator').click(); 
            
            // Usamos un intervalo para asegurarnos de que la API de pistas haya respondido 
            // antes de intentar auto-seleccionar y enrutar
            const checkInterval = setInterval(async () => {
                if (loadedTracks.length > 0) {
                    clearInterval(checkInterval);
                    const track = loadedTracks.find(t => t.id == tId);
                    if(track) {
                        trackInput.value = track.name;
                        trackIdHidden.value = track.id;
                        await trackInput.dispatchEvent(new Event('change'));
                    }
                    setTimeout(() => { raceSel.value = rId; raceSel.dispatchEvent(new Event('change')); }, 500);
                }
            }, 100);
        };

        // ⭐ Lógica de búsqueda por teclado para la creación de sala
        trackInput.addEventListener('change', async () => {
            stopAutoRefresh();
            raceSel.innerHTML = '<option>Cargando...</option>'; raceSel.disabled = true; workspace.classList.add('hidden');
            
            const selectedName = trackInput.value.trim();
            const selectedTrack = loadedTracks.find(t => t.name === selectedName);
            
            if(!selectedTrack) {
                raceSel.innerHTML = '<option>Hipódromo no encontrado</option>';
                return;
            }

            const tId = selectedTrack.id;
            trackIdHidden.value = tId;

            try {
                const races = await api.get(`/remate/races/${tId}?operatorName=${currentUser.username}`);
                raceSel.innerHTML = '<option value="">-- Selecciona Carrera --</option>' + races.filter(r => r.status === 'open' || r.status === 'scheduled').map(r => `<option value="${r.id}">Carrera ${r.race_number} - ${r.name}</option>`).join('');
                raceSel.disabled = false;
            } catch(e) { raceSel.innerHTML = '<option>Error</option>'; }
        });

        raceSel.onchange = async () => {
            stopAutoRefresh();
            const rId = raceSel.value; if(!rId) return workspace.classList.add('hidden');
            workspace.classList.remove('hidden'); pricesContainer.classList.add('hidden');
            statusBadge.innerText = "Consultando..."; statusBadge.className = "tabler-badge badge-gray";
            
            container.querySelectorAll('.vip-client-cb').forEach(cb => cb.checked = false);
            if (selectAllCb) selectAllCb.checked = false;

            try {
                const roomData = await api.get(`/remate/operator/vip-room/${rId}`);
                if (roomData.success && roomData.room) {
                    currentRoomId = roomData.room.id;
                    statusBadge.innerText = "Activa (Privada)"; statusBadge.className = "tabler-badge badge-green";
                    
                    const allowed = roomData.room.allowed_users || [];
                    let allChecked = true;
                    
                    container.querySelectorAll('.vip-client-cb').forEach(cb => { 
                        if(allowed.includes(parseInt(cb.value))) {
                            cb.checked = true;
                        } else {
                            allChecked = false;
                        }
                    });
                    
                    if (selectAllCb && allowed.length > 0) selectAllCb.checked = allChecked;

                    btnSaveRoom.classList.add('hidden');
                    btnUpdateUsers.classList.remove('hidden');

                    const manualPote = roomData.room.manual_pote || 0;
                    const wData = typeof roomData.room.wagers_data === 'string' ? JSON.parse(roomData.room.wagers_data) : (roomData.room.wagers_data || {});
                    container.querySelector('#vip-manual-pote').value = manualPote;
                    container.querySelector('#vip-remate-duration').value = wData.remate_duration || '';
                    container.querySelector('#vip-close-before').value = wData.close_before || '';

                    await loadVipHorses(rId, currentRoomId);
                    vipAutoRefresh = setInterval(() => loadVipHorses(rId, currentRoomId, true), 3000);
                } else {
                    currentRoomId = null;
                    statusBadge.innerText = "No Creada"; statusBadge.className = "tabler-badge badge-gray";
                    btnSaveRoom.classList.remove('hidden');
                    btnUpdateUsers.classList.add('hidden');
                }
            } catch(e) { console.error("Error consultando sala"); }
        };

        btnSaveRoom.onclick = async (e) => {
            const rId = raceSel.value;
            const checkedUsers = Array.from(container.querySelectorAll('.vip-client-cb:checked')).map(cb => parseInt(cb.value));
            if (checkedUsers.length === 0) return Notification(notificationContainer, "Selecciona al menos un cliente.", "warning");
            
            const btn = e.currentTarget; btn.disabled = true; btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i>';
            try {
                const res = await api.post('/remate/operator/vip-room', { raceId: parseInt(rId), allowedUsers: checkedUsers });
                currentRoomId = res.roomId;
                statusBadge.innerText = "Activa (Privada)"; statusBadge.className = "tabler-badge badge-green";
                btnSaveRoom.classList.add('hidden'); btnUpdateUsers.classList.remove('hidden');
                Notification(notificationContainer, 'Sala Creada con Éxito.', 'success');
                await loadVipHorses(rId, currentRoomId);
                if(!vipAutoRefresh) vipAutoRefresh = setInterval(() => loadVipHorses(rId, currentRoomId, true), 3000);
            } catch(e) { Notification(notificationContainer, e.message, 'error'); } 
            finally { btn.disabled = false; btn.innerHTML = '<i class="fas fa-lock"></i> Crear Sala VIP'; }
        };

        btnUpdateUsers.onclick = async (e) => {
            const rId = raceSel.value;
            const checkedUsers = Array.from(container.querySelectorAll('.vip-client-cb:checked')).map(cb => parseInt(cb.value));
            if (checkedUsers.length === 0) return Notification(notificationContainer, "Selecciona al menos un cliente.", "warning");
            
            const btn = e.currentTarget; btn.disabled = true; btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i>';
            try {
                await api.post('/remate/operator/vip-room', { raceId: parseInt(rId), roomId: currentRoomId, allowedUsers: checkedUsers });
                Notification(notificationContainer, 'Invitados actualizados.', 'success');
            } catch(e) { Notification(notificationContainer, e.message, 'error'); } 
            finally { btn.disabled = false; btn.innerHTML = '<i class="fas fa-user-plus"></i> Guardar Invitados'; }
        };

        container.querySelector('#btn-save-vip-config').onclick = async (e) => {
            if (!currentRoomId) return Notification(notificationContainer, "Crea la sala primero.", "warning");
            const btn = e.currentTarget; const origHTML = btn.innerHTML;
            btn.disabled = true; btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i>';
            const manual_pote = parseFloat(container.querySelector('#vip-manual-pote').value) || 0;
            const remate_duration = parseInt(container.querySelector('#vip-remate-duration').value) || 0;
            const close_before = parseInt(container.querySelector('#vip-close-before').value) || 0;
            
            try {
                await api.post('/remate/operator/vip-room/config', { roomId: currentRoomId, manual_pote, wagers_data: { remate_duration, close_before } });
                Notification(notificationContainer, 'Configuración de sala guardada.', 'success');
                btn.innerHTML = '<i class="fas fa-check"></i>'; setTimeout(() => { btn.innerHTML = origHTML; btn.disabled = false; }, 1500);
            } catch(err) { btn.innerHTML = origHTML; btn.disabled = false; }
        };

        const loadVipHorses = async (raceId, roomId, isSilent = false) => {
            pricesContainer.classList.remove('hidden');
            if(!isSilent) horsesBody.innerHTML = '<tr><td colspan="4" class="text-center text-muted"><i class="fas fa-spinner fa-spin"></i> Monitor...</td></tr>';
            
            try {
                const data = await api.get(`/remate/horses/${raceId}`);
                const horses = data.horses || [];
                if(horses.length === 0) return horsesBody.innerHTML = '<tr><td colspan="4" class="text-center text-muted">No hay caballos.</td></tr>';

                let wData = {};
                if (data.race_info && data.race_info.wagers_data) {
                    wData = typeof data.race_info.wagers_data === 'string' ? JSON.parse(data.race_info.wagers_data) : data.race_info.wagers_data;
                }
                const pricesSet = wData.prices_set === true;

                let livePote = 0;

                const htmlContent = horses.map(h => {
                    const isVirgin = h.owner_name === 'CASA';
                    const inheritedBase = pricesSet ? (h.base_price || 0) : 0;
                    const currentBid = h.amount !== undefined ? h.amount : inheritedBase;
                    
                    if (!h.is_withdrawn) livePote += currentBid;

                    return `
                        <tr style="${h.is_withdrawn ? 'opacity:0.5; background:rgba(239,68,68,0.1);' : ''}">
                            <td class="text-center font-bold" style="color:#D4AF37;">${h.horse_number}</td>
                            <td>
                                <div style="font-weight:600; color:#f8fafc; ${h.is_withdrawn ? 'text-decoration:line-through;' : ''}">${h.name}</div>
                                <div style="font-size:0.75rem; color:${isVirgin ? '#94a3b8' : '#60a5fa'}; margin-top:2px;">
                                    <i class="fas ${isVirgin ? 'fa-building' : 'fa-user'}"></i> ${isVirgin ? 'Sin Pujas' : h.owner_name}
                                </div>
                            </td>
                            <td>
                                <div style="display:flex; align-items:center; gap:5px;">
                                    <span style="color:#10b981; font-weight:bold;">$</span>
                                    <input type="number" id="vip-base-${h.id}" class="tabler-input font-mono" value="${currentBid}" style="width:80px; padding:6px; font-weight:700; ${!isVirgin ? 'border-color:#3b82f6; color:#60a5fa;' : ''}" ${!isVirgin ? 'disabled' : ''}>
                                </div>
                            </td>
                            <td class="text-center">
                                ${isVirgin ? `<button class="tabler-btn btn-success btn-save-vip-price" data-hid="${h.id}" style="padding:6px 12px;"><i class="fas fa-save"></i></button>` : `<span style="color:#10b981; font-size:0.8rem; font-weight:600;"><i class="fas fa-check"></i> OK</span>`}
                            </td>
                        </tr>
                    `;
                }).join('');

                container.querySelector('#live-pote-display').innerText = `Pote: $${livePote.toFixed(2)}`;

                if (horsesBody.dataset.lastHtml !== htmlContent) {
                    horsesBody.innerHTML = htmlContent;
                    horsesBody.dataset.lastHtml = htmlContent;

                    horsesBody.querySelectorAll('.btn-save-vip-price').forEach(btn => {
                        btn.onclick = async (e) => {
                            const hid = e.currentTarget.dataset.hid;
                            const val = parseFloat(document.getElementById(`vip-base-${hid}`).value);
                            if(isNaN(val)) return;

                            const oText = btn.innerHTML;
                            btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i>'; btn.disabled = true;

                            try {
                                await api.post('/remate/set-base-price', { horse_id: parseInt(hid), race_id: parseInt(raceId), base_price: val, room_id: currentRoomId });
                                btn.innerHTML = '<i class="fas fa-check"></i>'; btn.style.background = '#3b82f6';
                                setTimeout(() => { btn.innerHTML = oText; btn.disabled = false; btn.style.background = ''; }, 1500);
                            } catch(err) { btn.innerHTML = oText; btn.disabled = false; }
                        };
                    });
                }
            } catch(e) {}
        };

        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.attributeName === 'class' && document.getElementById('detailView').classList.contains('hidden')) {
                     stopAutoRefresh(); observer.disconnect();
                }
            });
        });
        observer.observe(document.getElementById('detailView'), { attributes: true });
    };

    const renderMyCustomRaces = async (container) => {
        container.innerHTML = `
            <div class="tabler-card">
                <div class="tabler-card-header">
                    <h3 class="tabler-card-title"><i class="fas fa-calendar-check text-green-400"></i> Remates Anticipados</h3>
                </div>
                <div class="tabler-card-body">
                    <p class="content-desc">Aquí aparecen automáticamente las carreras adelantadas asignadas a tu taquilla. Monitorea el pote, fija precios base o cierra las apuestas anticipadamente.</p>
                    <div id="custom-races-grid" class="widget-grid" style="gap:1.5rem;">
                        <div class="loader-container"><i class="fas fa-spinner fa-spin"></i> Cargando...</div>
                    </div>
                </div>
            </div>
            
            <div id="custom-prices-container" class="tabler-card hidden">
                <div class="tabler-card-header" style="flex-wrap: wrap; gap: 10px;">
                    <h3 class="tabler-card-title" id="custom-race-title" style="color: #10b981;"><i class="fas fa-gavel"></i> Panel de Subasta</h3>
                    <div style="display: flex; gap: 10px; flex-wrap: wrap;">
                        <button class="tabler-btn btn-danger" id="btn-close-custom-race"><i class="fas fa-lock"></i> Cerrar Carrera</button>
                        <button class="tabler-btn btn-secondary" onclick="document.getElementById('custom-prices-container').classList.add('hidden')"><i class="fas fa-arrow-left"></i> Volver</button>
                    </div>
                </div>

                <div class="tabler-card-body">
                    <div id="custom-race-stats" style="display:flex; gap:20px; background:rgba(255,255,255,0.02); padding:1.25rem; border-radius:8px; border:1px solid #334155; margin-bottom:1.5rem;">
                       <i class="fas fa-spinner fa-spin text-muted"></i> Calculando...
                    </div>

                    <div class="tabler-table-container">
                        <table class="tabler-table">
                            <thead><tr><th class="text-center">#</th><th>Ejemplar</th><th>Pujas</th><th class="text-center">Fijar Base ($)</th></tr></thead>
                            <tbody id="custom-horses-body"></tbody>
                        </table>
                    </div>
                </div>
            </div>
        `;

        const grid = container.querySelector('#custom-races-grid');
        try {
            const races = await api.get('/remate/operator/custom-races');
            if (races.length === 0) {
                grid.innerHTML = '<div style="grid-column: 1 / -1; text-align:center; padding:30px; color:#94a3b8;">No hay carreras anticipadas asignadas.</div>';
                return;
            }
            grid.innerHTML = races.map(r => {
                const dateStr = moment(r.start_time).format('DD MMM - hh:mm A');
                const totalPote = parseFloat(r.total_pool || r.total_pujas || r.manual_pote || 0).toFixed(2);
                const players = r.users_count || r.players_count || 0;
                
                const statusColor = r.status === 'open' ? '#10b981' : (r.status === 'scheduled' ? '#f59e0b' : '#ef4444');
                const statusText = r.status === 'open' ? 'ABIERTA' : (r.status === 'scheduled' ? 'PROGRAMADA' : 'CERRADA');

                return `
                <div class="widget-box" style="border-left: 4px solid ${statusColor}; cursor:pointer;" onclick="window.editCustomRacePrices(${r.race_id}, '${r.track_name} - C${r.race_number}', '${r.status}')">
                    <div style="display:flex; justify-content:space-between; width:100%; margin-bottom:5px;">
                        <div style="font-size:0.75rem; color:${statusColor}; font-weight:700;">${statusText}</div>
                        <div style="font-size:0.75rem; color:#94a3b8;"><i class="fas fa-users"></i> ${players}</div>
                    </div>
                    <h3 style="font-size:1.15rem; margin:0 0 5px 0; color: #f8fafc;">${r.track_name}</h3>
                    <p style="margin:0 0 10px 0; color:#94a3b8; font-size: 0.85rem;">Carrera ${r.race_number} <br>${dateStr}</p>
                    <div style="border-top: 1px solid #334155; padding-top: 10px; width: 100%; display: flex; justify-content: space-between; align-items: center;">
                        <span style="font-size:0.8rem; color:#cbd5e1;">Pote Acum:</span>
                        <span style="color:#D4AF37; font-weight:700; font-family:monospace; font-size: 1.1rem;">$${totalPote}</span>
                    </div>
                </div>`;
            }).join('');
        } catch(e) { grid.innerHTML = '<div class="text-danger">Error de servidor.</div>'; }

        window.editCustomRacePrices = async (raceId, title, status) => {
            const cont = container.querySelector('#custom-prices-container');
            const tbody = container.querySelector('#custom-horses-body');
            const statsDiv = container.querySelector('#custom-race-stats');
            const btnCloseRace = container.querySelector('#btn-close-custom-race');

            document.getElementById('custom-race-title').innerText = title;
            cont.classList.remove('hidden');
            
            if (status === 'closed' || status === 'finished') btnCloseRace.style.display = 'none';
            else { btnCloseRace.style.display = 'inline-flex'; btnCloseRace.onclick = () => window.closeCustomRace(raceId); }

            tbody.innerHTML = '<tr><td colspan="4" class="text-center text-muted"><i class="fas fa-spinner fa-spin"></i> Auditando subastas...</td></tr>';
            
            try {
                const data = await api.get(`/remate/horses/${raceId}`);
                const horses = data.horses || [];
                
                let livePote = 0; let activeHorsesCount = 0;

                tbody.innerHTML = horses.map(h => {
                    const isVirgin = h.owner_name === 'CASA' || !h.owner_name;
                    const currentBid = h.amount !== undefined ? h.amount : (h.base_price || 0);
                    
                    if (!h.is_withdrawn) { livePote += currentBid; activeHorsesCount++; }

                    return `
                    <tr style="${h.is_withdrawn ? 'opacity:0.5; background:rgba(239,68,68,0.1);' : ''}">
                        <td class="text-center font-bold" style="color:#D4AF37;">${h.horse_number}</td>
                        <td>
                            <div style="font-weight:600; color:#f8fafc; ${h.is_withdrawn ? 'text-decoration:line-through;' : ''}">${h.name}</div>
                            ${h.is_withdrawn ? '<span style="font-size:0.7rem; color:#ef4444; font-weight:700;">RETIRADO</span>' : ''}
                        </td>
                        <td>
                            <div class="font-mono" style="font-size:1.05rem; color:#10b981; font-weight:700;">$${parseFloat(currentBid).toFixed(2)}</div>
                            <div style="font-size:0.75rem; color:${isVirgin ? '#94a3b8' : '#60a5fa'}; margin-top:2px;">
                                <i class="fas ${isVirgin ? 'fa-building' : 'fa-user'}"></i> ${isVirgin ? 'Base' : h.owner_name}
                            </div>
                        </td>
                        <td style="display:flex; gap:5px; align-items: center; justify-content:center;">
                            <input type="number" id="custom-base-${h.id}" class="tabler-input font-mono" value="${h.base_price || 0}" style="width:80px; padding:6px;" ${!isVirgin ? 'disabled' : ''}>
                            ${isVirgin ? `<button class="tabler-btn btn-success" onclick="window.saveCustomPrice(${h.id}, ${raceId}, this)"><i class="fas fa-save"></i></button>` : `<span style="color:#10b981; font-size:0.8rem; font-weight:600;"><i class="fas fa-lock"></i></span>`}
                        </td>
                    </tr>
                `}).join('');

                statsDiv.innerHTML = `
                    <div style="flex:1; border-right: 1px solid #334155; padding-right: 15px;">
                        <span style="font-size:0.75rem; color:#94a3b8; text-transform:uppercase; font-weight:700;">Pote Acumulado</span>
                        <div class="font-mono" style="font-size:1.75rem; font-weight:700; color:#D4AF37;">$${livePote.toFixed(2)}</div>
                    </div>
                    <div style="flex:1; padding-left: 10px;">
                        <span style="font-size:0.75rem; color:#94a3b8; text-transform:uppercase; font-weight:700;">Ejemplares</span>
                        <div style="font-size:1.75rem; font-weight:700; color:#f8fafc;">${activeHorsesCount}</div>
                    </div>
                `;
            } catch(e) { tbody.innerHTML = '<tr><td colspan="4" class="text-danger text-center">Error de red.</td></tr>'; }
        };

        window.saveCustomPrice = async (hid, rid, btn) => {
            const val = parseFloat(document.getElementById(`custom-base-${hid}`).value);
            if(isNaN(val)) return;
            const oText = btn.innerHTML;
            btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i>'; btn.disabled = true;
            try {
                await api.post('/remate/set-base-price', { horse_id: parseInt(hid), race_id: parseInt(rid), base_price: val, room_id: null });
                btn.innerHTML = '<i class="fas fa-check"></i>'; btn.style.background = '#3b82f6';
                setTimeout(() => { 
                    btn.innerHTML = oText; btn.disabled = false; btn.style.background = '';
                    window.editCustomRacePrices(rid, document.getElementById('custom-race-title').innerText);
                }, 1000);
            } catch(err) { btn.innerHTML = oText; btn.disabled = false; }
        };

        window.closeCustomRace = async (raceId) => {
            if(!confirm("⚠️ ¿CERRAR MANUALMENTE esta carrera anticipada? Los clientes ya no podrán apostar.")) return;
            try {
                const nowUTC = moment().utc().toISOString();
                await api.put(`/races/${raceId}`, { status: 'closed', start_time: nowUTC });
                Notification(notificationContainer, "Carrera Cerrada.", "success");
                document.getElementById('custom-prices-container').classList.add('hidden');
                renderMyCustomRaces(container);
            } catch(e) { Notification(notificationContainer, "Error al cerrar", "error"); }
        };
    };

    // =========================================================================
    // 📤 VISTA: SOLICITUDES DE RETIRO (Solo de sus clientes)
    // =========================================================================
    const renderWithdrawals = async (container) => {
        container.innerHTML = `
            <div class="tabler-card">
                <div class="tabler-card-header">
                    <h3 class="tabler-card-title"><i class="fas fa-hand-holding-usd text-yellow-500"></i> Gestión de Retiros</h3>
                </div>
                <div class="tabler-card-body">
                    <p class="content-desc">Aprueba los pagos enviados o recházalos para devolver el saldo virtual a la cuenta del cliente.</p>

                    <div class="nav-tabs" style="margin-bottom: 1.5rem; flex-wrap: wrap;">
                        <button class="nav-tab active" data-status="PENDING"><i class="fas fa-clock text-yellow-400"></i> Pendientes</button>
                        <button class="nav-tab" data-status="APPROVED"><i class="fas fa-check-circle text-success"></i> Aprobados</button>
                        <button class="nav-tab" data-status="REJECTED"><i class="fas fa-times-circle text-danger"></i> Rechazados</button>
                    </div>
                    
                    <div class="tabler-table-container">
                        <table class="tabler-table">
                            <thead><tr><th>Fecha / Ref</th><th>Cliente</th><th class="text-right">Monto</th><th>Datos de Pago</th><th class="text-center">Acción</th></tr></thead>
                            <tbody id="withdrawalsBody"></tbody>
                        </table>
                    </div>
                </div>
            </div>
        `;

        let currentStatus = 'PENDING';
        const tbody = container.querySelector('#withdrawalsBody');

        container.querySelectorAll('.nav-tab').forEach(tab => {
            tab.onclick = (e) => {
                container.querySelectorAll('.nav-tab').forEach(t => t.classList.remove('active'));
                e.currentTarget.classList.add('active');
                currentStatus = e.currentTarget.dataset.status;
                loadWithdrawals();
            };
        });

        const loadWithdrawals = async () => {
            tbody.innerHTML = '<tr><td colspan="5" class="loader-container"><i class="fas fa-spinner fa-spin"></i><br>Buscando solicitudes...</td></tr>';
            try {
                const txs = await api.get(`/remate/transactions?type=WITHDRAW_REQUEST&status=${currentStatus}`);
                const myTxs = txs.filter(t => cashierState.myClientIds.has(t.user_id));
                
                if (myTxs.length === 0) {
                    tbody.innerHTML = '<tr><td colspan="5" class="text-center text-muted" style="padding: 40px 0;">No hay solicitudes en este estado.</td></tr>';
                    return;
                }

                tbody.innerHTML = myTxs.map(t => {
                    const dateStr = new Date(t.created_at).toLocaleString('es-VE', {day:'2-digit', month:'2-digit', hour:'2-digit', minute:'2-digit'});
                    const amountVal = parseFloat(t.amount).toLocaleString('es-VE', { minimumFractionDigits: 2 });
                    
                    let actions = `<span class="text-muted" style="font-style:italic;">Procesado</span>`;
                    if (t.status === 'PENDING') {
                        actions = `
                            <div style="display:flex; gap:8px; justify-content:center;">
                                <button class="btn-icon-green btn-approve" data-id="${t.id}" title="Aprobar"><i class="fas fa-check"></i></button>
                                <button class="btn-icon-red btn-reject" data-id="${t.id}" title="Rechazar"><i class="fas fa-times"></i></button>
                            </div>
                        `;
                    }

                    return `
                        <tr>
                            <td>
                                <div style="font-weight:600; color:#f8fafc;">#${t.id}</div>
                                <div class="text-muted" style="font-size:0.8rem;">${dateStr}</div>
                            </td>
                            <td><div style="font-weight:600; color:#D4AF37;">${t.user_alias || t.user_username}</div></td>
                            <td class="text-right font-mono" style="color:#f87171; font-weight:700; font-size:1.05rem;">- Bs. ${amountVal}</td>
                            <td class="text-muted" style="max-width:250px; white-space:normal; line-height:1.4;">${t.description}</td>
                            <td class="text-center" style="vertical-align:middle;">${actions}</td>
                        </tr>
                    `;
                }).join('');

                tbody.querySelectorAll('.btn-approve').forEach(btn => {
                    btn.onclick = async () => {
                        if(!confirm("✅ ¿Confirmas que ya transferiste el dinero a este cliente?")) return;
                        const orig = btn.innerHTML; btn.disabled = true; btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i>';
                        try {
                            await api.post(`/remate/transactions/${btn.dataset.id}/resolve`, { action: 'APPROVE' });
                            Notification(notificationContainer, 'Retiro marcado como pagado exitosamente.', 'success');
                            loadWithdrawals();
                        } catch(e) { Notification(notificationContainer, e.message, 'error'); btn.disabled = false; btn.innerHTML = orig; }
                    };
                });

                tbody.querySelectorAll('.btn-reject').forEach(btn => {
                    btn.onclick = async () => {
                        if(!confirm("❌ ¿Rechazar solicitud? El saldo retenido será DEVUELTO a la cuenta del cliente en la app.")) return;
                        const orig = btn.innerHTML; btn.disabled = true; btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i>';
                        try {
                            await api.post(`/remate/transactions/${btn.dataset.id}/resolve`, { action: 'REJECT' });
                            Notification(notificationContainer, 'Retiro rechazado y saldo devuelto.', 'success');
                            loadWithdrawals();
                        } catch(e) { Notification(notificationContainer, e.message, 'error'); btn.disabled = false; btn.innerHTML = orig; }
                    };
                });

            } catch (e) { tbody.innerHTML = '<tr><td colspan="5" class="text-center text-danger" style="padding: 40px 0;">Error de red al cargar solicitudes.</td></tr>'; }
        };

        loadWithdrawals();
    };

    // =========================================================================
    // 📊 VISTA: REPORTES (CUADRE DE CAJA HISTÓRICO DEL OPERADOR)
    // =========================================================================
    const renderReports = async (container) => {
        container.innerHTML = `
            <div class="tabler-card">
                <div class="tabler-card-header">
                    <h3 class="tabler-card-title"><i class="fas fa-file-invoice-dollar text-gray-400"></i> Cuadre de Caja Histórico</h3>
                </div>
                <div class="tabler-card-body">
                    <p class="content-desc">Genera el reporte financiero de fechas pasadas para conciliar balances de Win/Place y Remates.</p>

                    <div class="filter-grid">
                        <div class="filter-group"><label>Desde</label><input type="date" id="rep-start" class="tabler-input" value="${moment().startOf('isoWeek').format('YYYY-MM-DD')}"></div>
                        <div class="filter-group"><label>Hasta</label><input type="date" id="rep-end" class="tabler-input" value="${moment().format('YYYY-MM-DD')}"></div>
                        <div class="filter-group">
                            <label style="color:#10b981;">Mi Comisión Configurada</label>
                            <input type="text" class="tabler-input font-mono" value="${cashierState.commissionType === 'FIXED' ? '$' : ''}${cashierState.comisionRate}${cashierState.commissionType !== 'FIXED' ? '%' : ''}" readonly style="border-color:#10b981; color:#10b981; font-weight:700;">
                        </div>
                        <button id="btn-generate-report" class="tabler-btn btn-primary" style="height: 38px;"><i class="fas fa-search"></i> Generar Cuadre</button>
                    </div>

                    <div id="report-results" style="margin-top: 2rem;"></div>
                </div>
            </div>
        `;

        container.querySelector('#btn-generate-report').onclick = async () => {
            const start = container.querySelector('#rep-start').value;
            const end = container.querySelector('#rep-end').value;
            const resDiv = container.querySelector('#report-results');
            
            if(!start || !end) return Notification(notificationContainer, "Fechas obligatorias", "warning");

            resDiv.innerHTML = '<div class="loader-container"><i class="fas fa-spinner fa-spin"></i><br>Calculando balance...</div>';

            try {
                const params = new URLSearchParams({
                    startDate: `${start} 00:00:00`,
                    endDate: `${end} 23:59:59`,
                    allyName: currentUser.username 
                });

                const data = await api.get(`/remate/reports/detailed-bets?${params.toString()}`);
                
                if (!data || data.length === 0) {
                    resDiv.innerHTML = `
                        <div style="background: rgba(239, 68, 68, 0.05); border: 1px dashed #ef4444; padding: 40px; text-align: center; border-radius: 8px;">
                            <i class="fas fa-box-open" style="font-size: 3rem; color: #ef4444; margin-bottom: 15px; opacity: 0.8;"></i>
                            <h3 style="color: #ef4444; margin: 0 0 10px 0;">No hay datos</h3>
                            <p class="text-muted m-0">No se registró actividad financiera en este periodo.</p>
                        </div>`;
                    return;
                }

                const userTotals = new Map();
                data.forEach(b => {
                    const isOutbidOrRefunded = b.category === 'REMATE' && (b.status === 'lost' || b.status === 'refunded' || b.status === 'scratched');
                    const played = isOutbidOrRefunded ? 0 : parseFloat(b.amount || 0);
                    
                    // ⭐ FIX: Convertir pagos de REMATE (guardados en Bs) a USD
                    let paid = parseFloat(b.payout || 0);
                    if (b.category === 'REMATE' && paid > 0 && cashierState.exchangeRate > 0) {
                        paid = paid / cashierState.exchangeRate;
                    }
                    
                    if (!userTotals.has(b.user_id)) {
                        userTotals.set(b.user_id, { alias: b.user_alias || b.username, played: 0, paid: 0 });
                    }
                    const ut = userTotals.get(b.user_id);
                    ut.played += played;
                    ut.paid += paid;
                });

                let totalJugado = 0, totalPremios = 0, totalNeto = 0, totalComision = 0;

                let tableHtml = `
                    <div class="tabler-table-container">
                    <table class="tabler-table">
                        <thead>
                            <tr>
                                <th>Cliente</th>
                                <th class="text-right">Jugado ($)</th>
                                <th class="text-right">Premios Pagados ($)</th>
                                <th class="text-right">Balance Neto ($)</th>
                                <th class="text-right" style="color: #10b981;">Tu Comisión</th>
                            </tr>
                        </thead>
                        <tbody>
                `;

                for (const [uid, row] of userTotals.entries()) {
                    if (row.played === 0 && row.paid === 0) continue;
                    const neto = row.played - row.paid;
                    
                    let comision = 0;
                    if (cashierState.commissionType === 'PERCENT' && neto > 0) comision = neto * (cashierState.comisionRate / 100);
                    else if (cashierState.commissionType === 'PERCENT_SALES') comision = row.played * (cashierState.comisionRate / 100);
                    else if (cashierState.commissionType === 'FIXED' && row.played > 0) comision = cashierState.comisionRate;

                    totalJugado += row.played; totalPremios += row.paid; totalNeto += neto; totalComision += comision;

                    tableHtml += `
                        <tr>
                            <td><div style="font-weight:600; color:#f8fafc;">${row.alias}</div></td>
                            <td class="text-right font-mono">$${row.played.toFixed(2)}</td>
                            <td class="text-right font-mono" style="color:#f87171;">$${row.paid.toFixed(2)}</td>
                            <td class="text-right font-mono" style="font-weight:600; color: ${neto >= 0 ? '#34d399' : '#f87171'}">${neto >= 0 ? '+' : ''}$${neto.toFixed(2)}</td>
                            <td class="text-right font-mono" style="color:#10b981; font-weight:700;">$${comision.toFixed(2)}</td>
                        </tr>
                    `;
                }

                tableHtml += `
                        </tbody>
                        <tfoot>
                            <tr>
                                <td style="color:#D4AF37;">TOTALES:</td>
                                <td class="text-right font-mono">$${totalJugado.toFixed(2)}</td>
                                <td class="text-right font-mono" style="color:#f87171;">$${totalPremios.toFixed(2)}</td>
                                <td class="text-right font-mono" style="font-size:1.15rem; color:${totalNeto >= 0 ? '#34d399' : '#f87171'};">${totalNeto >= 0 ? '+' : ''}$${totalNeto.toFixed(2)}</td>
                                <td class="text-right font-mono" style="font-size:1.25rem; color:#10b981;">$${totalComision.toFixed(2)}</td>
                            </tr>
                        </tfoot>
                    </table>
                    </div>
                `;
                resDiv.innerHTML = tableHtml;

            } catch (e) { resDiv.innerHTML = '<div class="text-center text-danger py-5">Error generando reporte.</div>'; }
        };
    };

    // =========================================================================
    // 📱 VISTA: COMPARTIR APP MÓVIL (QR / LINK)
    // =========================================================================
    const renderQRApp = (container) => {
        const appUrl = window.location.origin + "/remate-app/?operator=" + encodeURIComponent(currentUser.username);
        const qrApiUrl = 'https://api.qrserver.com/v1/create-qr-code/?size=250x250&data=' + encodeURIComponent(appUrl) + '&margin=10';

        container.innerHTML = `
            <div class="tabler-card">
                <div class="tabler-card-header">
                    <h3 class="tabler-card-title"><i class="fas fa-qrcode text-white"></i> Compartir Aplicación</h3>
                </div>
                <div class="tabler-card-body" style="text-align: center;">
                    <p class="content-desc">Muestra este código a tus clientes. Al registrarse, quedarán automáticamente vinculados a tu taquilla bajo el código <b>${currentUser.username}</b>.</p>
                    
                    <div style="background: white; padding: 15px; border-radius: 12px; display: inline-block; margin-bottom: 20px;">
                        <img id="qr-img" src="${qrApiUrl}" alt="Código QR de la App" style="width: 200px; height: 200px;">
                    </div>

                    <div class="form-group" style="max-width: 500px; margin: 0 auto; text-align: left;">
                        <label>Enlace Directo</label>
                        <input type="text" id="apk-url" class="tabler-input font-mono" value="${appUrl}" readonly title="Toca para copiar" style="cursor: copy; color:#3b82f6;">
                        <small class="text-muted" style="display:block; margin-top:8px;">Toca el enlace para copiarlo y enviarlo por WhatsApp.</small>
                    </div>
                </div>
            </div>
        `;

        const urlInput = container.querySelector('#apk-url');
        urlInput.addEventListener('click', () => {
            navigator.clipboard.writeText(urlInput.value).then(() => {
                Notification(notificationContainer, 'Enlace copiado.', 'success');
            });
        });
    };

    // =========================================================================
    // 📡 VISTA: MONITOR EN VIVO (TREE GRID OPTIMIZADO)
    // =========================================================================
    const renderLiveMonitor = (container) => {
        let liveInterval = null; 
        let allBets = []; 
        let expandedUsers = new Set(); 
        let isAutoRefresh = true;
        let currentCategory = 'DIGITAL'; 

        const treeStyles = `
            <style>
                .mon-tree-node { background: #0f172a; border: 1px solid #334155; border-radius: 8px; margin-bottom: 10px; overflow: hidden; }
                .mon-tree-header { display: flex; justify-content: space-between; align-items: center; padding: 12px 16px; cursor: pointer; transition: 0.2s; background: #1e293b; border-bottom: 1px solid transparent; }
                .mon-tree-header:hover { background: #232f45; border-color: #3b82f6; }
                .mon-tree-header.active { border-bottom-color: #334155; }
                .mon-tree-child { display: none; padding: 0; background: #0f172a; overflow-x: auto; }
                .mon-tree-child.open { display: block; animation: slideDown 0.3s ease forwards; }
                
                .badge-status { padding: 4px 8px; border-radius: 4px; font-size: 0.7rem; font-weight: 700; text-align: center; text-transform: uppercase; border: 1px solid transparent; }
                .status-WON { background: rgba(16,185,129,0.1); color: #34d399; border-color: rgba(16,185,129,0.2); }
                .status-LOST { background: rgba(239,68,68,0.1); color: #f87171; border-color: rgba(239,68,68,0.2); }
                .status-PENDING { background: rgba(59,130,246,0.1); color: #60a5fa; border-color: rgba(59,130,246,0.2); }
                .status-SCRATCHED { background: rgba(148,163,184,0.1); color: #94a3b8; border-color: rgba(148,163,184,0.2); }

                @media (max-width: 768px) {
                    .mon-tree-header { flex-direction: column; align-items: flex-start; gap: 10px; }
                    .mon-tree-header > div { width: 100%; display: flex; justify-content: space-between; }
                }
            </style>
        `;

        container.innerHTML = `
            ${treeStyles}
            <div class="tabler-card">
                <div class="tabler-card-header">
                    <h3 class="tabler-card-title"><i class="fas fa-satellite-dish text-red-400"></i> Auditoría en Vivo</h3>
                    <button id="toggle-autorefresh" class="tabler-btn btn-outline" style="color:#10b981; border-color:#10b981;"><i class="fas fa-sync fa-spin"></i> Auto: ON</button>
                </div>
                
                <div class="tabler-card-body">
                    <div class="nav-tabs" style="margin-bottom: 1.5rem; flex-wrap: wrap;">
                        <button class="nav-tab active" data-category="DIGITAL"><i class="fas fa-mobile-alt text-blue-400"></i> App (Win/Place)</button>
                        <button class="nav-tab" data-category="REMATE"><i class="fas fa-gavel text-yellow-400"></i> Subastas / VIP</button>
                    </div>

                    <div class="filter-grid" style="margin-bottom: 1.5rem;">
                        <div class="filter-group"><label>Desde</label><input type="date" id="filter-start" class="tabler-input" value="${moment().tz(VENEZUELA_TIMEZONE).format('YYYY-MM-DD')}"></div>
                        <div class="filter-group"><label>Hasta</label><input type="date" id="filter-end" class="tabler-input" value="${moment().tz(VENEZUELA_TIMEZONE).format('YYYY-MM-DD')}"></div>
                        <div class="filter-group"><label>Estado</label><select id="filter-status" class="tabler-select"><option value="ALL">Todos</option><option value="PENDING">En Juego</option><option value="WON">Ganadas</option><option value="LOST">Perdidas</option></select></div>
                        <button id="btn-apply-filters" class="tabler-btn btn-secondary" style="height: 38px;"><i class="fas fa-filter"></i> Aplicar</button>
                    </div>

                    <div id="tree-grid-wrapper">
                        <div class="loader-container"><i class="fas fa-spinner fa-spin"></i><br>Conectando auditoría...</div>
                    </div>
                </div>
            </div>
        `;

        const wrapper = container.querySelector('#tree-grid-wrapper');
        const btnToggleRefresh = container.querySelector('#toggle-autorefresh');
        const btnApply = container.querySelector('#btn-apply-filters');

        container.querySelectorAll('.nav-tab').forEach(tab => {
            tab.onclick = (e) => {
                container.querySelectorAll('.nav-tab').forEach(t => t.classList.remove('active'));
                e.currentTarget.classList.add('active');
                currentCategory = e.currentTarget.dataset.category;
                renderTree(); 
            };
        });

        btnToggleRefresh.onclick = () => {
            isAutoRefresh = !isAutoRefresh;
            if (isAutoRefresh) {
                btnToggleRefresh.style.color = '#10b981'; btnToggleRefresh.style.borderColor = '#10b981';
                btnToggleRefresh.innerHTML = '<i class="fas fa-sync fa-spin"></i> Auto: ON';
                fetchLiveData(); 
            } else {
                btnToggleRefresh.style.color = '#94a3b8'; btnToggleRefresh.style.borderColor = '#475569';
                btnToggleRefresh.innerHTML = '<i class="fas fa-pause-circle"></i> Auto: OFF';
            }
        };

        btnApply.onclick = () => fetchLiveData();

        const renderTree = () => {
            const filterStatus = container.querySelector('#filter-status').value;

            const filteredBets = allBets.filter(bet => {
                const matchStatus = filterStatus === 'ALL' || String(bet.status).toUpperCase() === filterStatus;
                const matchCategory = bet.category === currentCategory; 
                return matchStatus && matchCategory;
            });

            if (filteredBets.length === 0) {
                wrapper.innerHTML = `<div class="text-center text-muted" style="padding:40px 0;">No hay jugadas activas en esta pestaña.</div>`;
                return;
            }

            const grouped = filteredBets.reduce((acc, bet) => {
                const uid = bet.user_id;
                if (!acc[uid]) acc[uid] = { alias: bet.user_alias || bet.username || `ID ${uid}`, bets: [], total_played: 0, total_paid: 0 };
                
                const isRefunded = bet.category === 'REMATE' && (bet.status === 'refunded' || bet.status === 'scratched');
                if (!isRefunded) acc[uid].total_played += parseFloat(bet.amount || 0);
                
                // ⭐ FIX: Convertir, sumar y guardar el payout corregido para la tabla
                let paid = parseFloat(bet.payout || 0);
                if (bet.category === 'REMATE' && paid > 0 && cashierState.exchangeRate > 0) {
                    paid = paid / cashierState.exchangeRate;
                }
                bet.corrected_payout = paid; 
                
                acc[uid].total_paid += paid;
                acc[uid].bets.push(bet);
                return acc;
            }, {});

            let html = '<div class="live-tree-container">';
            let grandPlayed = 0, grandPaid = 0;

            Object.keys(grouped).forEach(uid => {
                const g = grouped[uid];
                const net = g.total_paid - g.total_played; 
                const isExpanded = expandedUsers.has(uid);
                
                grandPlayed += g.total_played;
                grandPaid += g.total_paid;

                html += `
                    <div class="mon-tree-node" data-uid="${uid}">
                        <div class="mon-tree-header ${isExpanded ? 'active' : ''}">
                            <div style="font-weight:600; color:#f8fafc; font-size:1.05rem; display:flex; align-items:center; gap:10px;">
                                <i class="fas ${isExpanded ? 'fa-chevron-down' : 'fa-chevron-right'} text-muted" style="width:15px;"></i>
                                ${g.alias}
                            </div>
                            <div style="font-family:monospace; font-size:1rem; display:flex; gap:15px;">
                                <span class="text-muted">Jugado: <b style="color:white;">$${g.total_played.toFixed(2)}</b></span>
                                <span class="text-success">Premio: <b>$${g.total_paid.toFixed(2)}</b></span>
                            </div>
                        </div>

                        <div class="mon-tree-child ${isExpanded ? 'open' : ''}">
                            <table class="tabler-table" style="margin:0;">
                                <thead>
                                    <tr><th>Hora</th><th>Detalle</th><th>Tipo</th><th class="text-right">Monto</th><th class="text-right">Premio</th><th class="text-center">Estado</th></tr>
                                </thead>
                                <tbody>
                                    ${g.bets.map(b => {
                                        const dateStr = new Date(b.created_at).toLocaleTimeString('es-VE', { hour:'2-digit', minute:'2-digit' });
                                        const payout = b.corrected_payout !== undefined ? b.corrected_payout : parseFloat(b.payout || 0);
                                        const amountSafe = parseFloat(b.amount || 0);
                                        
                                        let statusText = 'EN JUEGO'; let statusClass = 'status-PENDING';

                                        if (b.category === 'REMATE') {
                                            if (b.status === 'won') { statusText = 'GANADA'; statusClass = 'status-WON'; } 
                                            else if (b.status === 'lost') { statusText = 'PERDIDA'; statusClass = 'status-LOST'; } 
                                            else if (b.status === 'refunded' || b.status === 'scratched') { statusText = 'RETIRADO'; statusClass = 'status-SCRATCHED'; } 
                                        } else {
                                            if (b.status === 'won' || b.status === 'paid') { statusText = 'GANADA'; statusClass = 'status-WON'; }
                                            else if (b.status === 'lost') { statusText = 'PERDIDA'; statusClass = 'status-LOST'; }
                                            else if (b.status === 'scratched' || b.status === 'refunded') { statusText = 'RETIRADO'; statusClass = 'status-SCRATCHED'; }
                                        }
                                        
                                        let typeDisplay = b.bet_type || 'WIN';
                                        if (b.category === 'REMATE') typeDisplay = `SUBASTA <br><small class="text-muted">${b.room_name}</small>`;

                                        const isRefundedVisual = (b.status === 'refunded' || b.status === 'scratched');

                                        return `
                                            <tr>
                                                <td class="text-muted" style="font-size:0.75rem;">${dateStr}</td>
                                                <td>
                                                    <div style="font-weight:600; color:#D4AF37;">${b.track_name || 'N/A'} - C${b.race_number || '-'}</div>
                                                    <div class="text-muted" style="font-size:0.8rem;">#${b.horse_number || '-'} ${b.horse_name || ''}</div>
                                                </td>
                                                <td style="font-size:0.8rem; font-weight:600;">${typeDisplay}</td>
                                                <td class="text-right font-mono" style="${isRefundedVisual ? 'text-decoration:line-through; color:#94a3b8;' : 'color:#f8fafc; font-weight:700;'}">$${amountSafe.toFixed(2)}</td>
                                                <td class="text-right font-mono" style="color:${payout>0?'#10b981':'#94a3b8'}; font-weight:700;">$${payout.toFixed(2)}</td>
                                                <td class="text-center"><span class="badge-status ${statusClass}">${statusText}</span></td>
                                            </tr>
                                        `;
                                    }).join('')}
                                </tbody>
                            </table>
                        </div>
                    </div>
                `;
            });

            html += `</div>`; 

            const grandNet = grandPlayed - grandPaid; 
            html += `
                <div style="background: rgba(255,255,255,0.02); border: 1px solid #334155; padding: 1.5rem; border-radius: 8px; margin-top: 1.5rem; display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap:10px;">
                    <div><div style="color: #94a3b8; font-size: 0.75rem; text-transform: uppercase; font-weight: 700;">Total Jugado</div><div class="font-mono" style="font-size: 1.25rem; font-weight: 700; color:#f8fafc;">$${grandPlayed.toFixed(2)}</div></div>
                    <div><div style="color: #94a3b8; font-size: 0.75rem; text-transform: uppercase; font-weight: 700;">Premios Proyectados</div><div class="font-mono" style="font-size: 1.25rem; font-weight: 700; color: #f87171;">-$${grandPaid.toFixed(2)}</div></div>
                    <div style="text-align: right; border-left: 1px solid #334155; padding-left: 15px;">
                        <div style="color: #D4AF37; font-size: 0.75rem; text-transform: uppercase; font-weight: 700;">GGR (Neto)</div>
                        <div class="font-mono" style="font-size: 1.5rem; font-weight: 700; color: ${grandNet >= 0 ? '#10b981' : '#f87171'};">${grandNet >= 0 ? '+' : ''}$${grandNet.toFixed(2)}</div>
                    </div>
                </div>
            `;

            wrapper.innerHTML = html;

            wrapper.querySelectorAll('.mon-tree-header').forEach(header => {
                header.onclick = (e) => {
                    const node = e.currentTarget.closest('.mon-tree-node');
                    const uid = node.dataset.uid;
                    const child = node.querySelector('.mon-tree-child');
                    const icon = header.querySelector('.fa-chevron-right, .fa-chevron-down');

                    if (expandedUsers.has(uid)) {
                        expandedUsers.delete(uid);
                        child.classList.remove('open');
                        header.classList.remove('active');
                        if(icon) { icon.classList.remove('fa-chevron-down'); icon.classList.add('fa-chevron-right'); }
                    } else {
                        expandedUsers.add(uid);
                        child.classList.add('open');
                        header.classList.add('active');
                        if(icon) { icon.classList.remove('fa-chevron-right'); icon.classList.add('fa-chevron-down'); }
                    }
                };
            });
        };

        const fetchLiveData = async () => {
            try {
                const start = container.querySelector('#filter-start').value;
                const end = container.querySelector('#filter-end').value;
                
                const params = new URLSearchParams({ startDate: `${start} 00:00:00`, endDate: `${end} 23:59:59`, allyName: currentUser.username });
                const data = await api.get(`/remate/reports/detailed-bets?${params.toString()}`);
                
                allBets = Array.isArray(data) ? data : [];
                renderTree();
            } catch (error) {
                if (allBets.length === 0) wrapper.innerHTML = '<div class="text-center text-danger py-5">Error de auditoría en vivo.</div>';
            }
        };

        fetchLiveData();

        liveInterval = setInterval(() => { if (isAutoRefresh) fetchLiveData(); }, 3000);

        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.attributeName === 'class' && document.getElementById('detailView').classList.contains('hidden')) {
                     clearInterval(liveInterval); observer.disconnect();
                }
            });
        });
        observer.observe(document.getElementById('detailView'), { attributes: true });
    };

    // =========================================================================
    // 💬 VISTA: GESTOR DE CHAT Y SOPORTE (B2B)
    // =========================================================================
    const renderChatManager = async (container) => {
        container.innerHTML = `
            <div class="tabler-card" style="height: calc(100vh - 200px); display: flex; flex-direction: column;">
                <div class="tabler-card-header">
                    <h3 class="tabler-card-title"><i class="fas fa-comments text-green-500"></i> Centro de Mensajería y Soporte</h3>
                </div>
                <div class="tabler-card-body" style="flex: 1; display: flex; gap: 15px; padding: 0; overflow: hidden; background: #0f172a;">
                    
                    <div style="width: 300px; border-right: 1px solid #334155; display: flex; flex-direction: column; background: #1e293b;">
                        <div class="nav-tabs" style="margin:0; padding: 10px; border-bottom: 1px solid #334155;">
                            <button class="nav-tab active" data-tab="clients" style="padding: 10px; font-size: 0.75rem;"><i class="fas fa-user"></i> Clientes</button>
                            <button class="nav-tab" data-tab="rooms" style="padding: 10px; font-size: 0.75rem;"><i class="fas fa-gavel"></i> Salas VIP</button>
                        </div>
                        <div id="chat-sidebar-list" style="flex:1; overflow-y:auto; padding: 10px;"></div>
                    </div>

                    <div style="flex: 1; display: flex; flex-direction: column; background: #0f172a; position: relative;">
                        <div id="chat-header-info" style="padding: 15px; border-bottom: 1px solid #334155; background: rgba(255,255,255,0.02); display: flex; align-items: center; gap: 10px;">
                            <i class="fas fa-comment-dots text-muted" style="font-size: 1.5rem;"></i>
                            <h4 style="margin:0; color:#f8fafc;">Selecciona un chat</h4>
                        </div>
                        
                        <div id="chat-messages-area" style="flex:1; overflow-y:auto; padding: 20px; display: flex; flex-direction: column; gap: 10px;">
                            <div class="text-center text-muted" style="margin-top: 50px;">
                                <i class="fas fa-inbox" style="font-size: 3rem; margin-bottom: 10px; opacity: 0.5;"></i>
                                <p>Selecciona un cliente o sala a la izquierda para chatear.</p>
                            </div>
                        </div>

                        <div id="chat-input-area" style="padding: 15px; border-top: 1px solid #334155; background: #1e293b; display: none; gap: 10px;">
                            <input type="text" id="chat-input" class="tabler-input" placeholder="Escribe un mensaje..." style="flex:1;">
                            <button id="chat-send-btn" class="tabler-btn btn-primary"><i class="fas fa-paper-plane"></i></button>
                        </div>
                    </div>
                </div>
            </div>
        `;

        const sidebarList = container.querySelector('#chat-sidebar-list');
        let currentActiveChatId = null;
        let currentActiveChatType = null; // 'client' o 'room'

        const renderSidebarClients = () => {
            sidebarList.innerHTML = cashierState.myClients.map(c => `
                <div class="chat-list-item" style="padding: 12px; border-bottom: 1px solid #334155; cursor: pointer; border-radius: 6px; margin-bottom: 5px; background: rgba(255,255,255,0.02);" data-id="${c.telegram_id}" data-type="client" data-name="${c.alias || c.username}">
                    <div style="font-weight:bold; color:#f8fafc;">${c.alias || c.username}</div>
                    <div style="font-size:0.75rem; color:#94a3b8;"><i class="fas fa-circle text-success" style="font-size:0.5rem;"></i> Disponible</div>
                </div>
            `).join('');
            attachSidebarListeners();
        };

        const renderSidebarRooms = async () => {
            sidebarList.innerHTML = '<div class="text-center text-muted" style="padding:20px;"><i class="fas fa-spinner fa-spin"></i> Buscando salas...</div>';
            try {
                const rooms = await api.get('/remate/operator/my-vip-rooms');
                if (rooms.length === 0) {
                    sidebarList.innerHTML = '<div class="text-center text-muted" style="padding:20px;">No tienes salas VIP activas.</div>';
                    return;
                }
                sidebarList.innerHTML = rooms.map(r => `
                    <div class="chat-list-item" style="padding: 12px; border-bottom: 1px solid #334155; cursor: pointer; border-radius: 6px; margin-bottom: 5px; background: rgba(255,255,255,0.02);" data-id="${r.id}" data-type="room" data-name="Sala: ${r.track_name} C${r.race_number}">
                        <div style="font-weight:bold; color:#f8fafc; font-size:0.9rem;">${r.track_name} - C${r.race_number}</div>
                        <div style="font-size:0.75rem; color:#D4AF37;"><i class="fas fa-users"></i> Grupo Público</div>
                    </div>
                `).join('');
                attachSidebarListeners();
            } catch(e) { sidebarList.innerHTML = '<div class="text-center text-danger">Error cargando salas.</div>'; }
        };

        const attachSidebarListeners = () => {
            sidebarList.querySelectorAll('.chat-list-item').forEach(item => {
                item.onclick = (e) => {
                    sidebarList.querySelectorAll('.chat-list-item').forEach(i => i.style.background = 'rgba(255,255,255,0.02)');
                    e.currentTarget.style.background = 'rgba(59, 130, 246, 0.2)';
                    
                    currentActiveChatId = e.currentTarget.dataset.id;
                    currentActiveChatType = e.currentTarget.dataset.type;
                    const name = e.currentTarget.dataset.name;
                    
                    const icon = currentActiveChatType === 'room' ? 'fa-users' : 'fa-user';
                    container.querySelector('#chat-header-info').innerHTML = `<i class="fas ${icon} text-blue-400" style="font-size: 1.5rem;"></i><h4 style="margin:0; color:#f8fafc;">${name}</h4>`;
                    container.querySelector('#chat-messages-area').innerHTML = `<div class="text-center text-muted" style="margin-top: 20px;"><small>Iniciando canal de comunicación...</small></div>`;
                    container.querySelector('#chat-input-area').style.display = 'flex';

                    // Si elegimos una Sala, el operador se inyecta en la sala para recibir su historial
                    if (currentActiveChatType === 'room') {
                        window.operatorSocket.emit('join_race_room', currentActiveChatId);
                    }
                };
            });
        };

        renderSidebarClients(); // Carga inicial
        
        container.querySelectorAll('.nav-tab').forEach(tab => {
            tab.onclick = (e) => {
                container.querySelectorAll('.nav-tab').forEach(t => t.classList.remove('active'));
                e.currentTarget.classList.add('active');
                if (e.currentTarget.dataset.tab === 'clients') renderSidebarClients();
                else renderSidebarRooms();
            };
        });

        // ⭐ LÓGICA DE WEBSOCKETS PARA EL PANEL DEL OPERADOR ⭐
        const chatInput = container.querySelector('#chat-input');
        const sendBtn = container.querySelector('#chat-send-btn');
        const messagesArea = container.querySelector('#chat-messages-area');

        if (typeof io === 'undefined') {
            const script = document.createElement('script');
            script.src = "https://cdn.socket.io/4.7.2/socket.io.min.js";
            script.onload = initOperatorChat;
            document.head.appendChild(script);
        } else {
            initOperatorChat();
        }

        function initOperatorChat() {
            if (!window.operatorSocket) {
                window.operatorSocket = io({ transports: ["websocket"] });
                // El operador se une al canal maestro de soporte
                window.operatorSocket.emit('join_operator');
            }

            // ⭐ FIX CRÍTICO: Desvincular eventos viejos para que no usen el DOM destruido al cambiar de pestaña
            window.operatorSocket.off('receive_message');
            window.operatorSocket.off('chat_history');
            
            window.operatorSocket.on('receive_message', (data) => {
                // 1. Si el mensaje es de una Sala
                if (data.roomId) {
                    if (currentActiveChatType === 'room' && String(currentActiveChatId) === String(data.roomId)) {
                        appendMessage(data.sender, data.text, data.sender === 'Soporte VIP');
                    }
                    return;
                }
                
                // 2. Si el mensaje es Directo de un cliente
                if (data.telegramId) {
                    if (currentActiveChatType === 'client' && String(currentActiveChatId) === String(data.telegramId)) {
                        appendMessage(data.sender, data.text, false);
                    } else {
                        // Alerta visual en la lista lateral
                        const clientRow = sidebarList.querySelector(`[data-id="${data.telegramId}"]`);
                        if (clientRow) {
                            clientRow.style.borderLeft = "4px solid #10b981";
                            Notification(notificationContainer, `Nuevo mensaje de ${data.sender}`, 'info');
                        }
                    }
                }
            });

            // Cargar Historial de Redis
            window.operatorSocket.on('chat_history', (messages) => {
                if (currentActiveChatType === 'room') {
                    messagesArea.innerHTML = '<div class="text-center text-muted" style="margin-bottom: 10px;"><small>Historial de la sala cargado.</small></div>';
                    messages.forEach(msg => {
                        appendMessage(msg.sender, msg.text, msg.sender === 'Soporte VIP');
                    });
                }
            });

            const sendMessage = () => {
                const text = chatInput.value.trim();
                if (!text || !currentActiveChatId) return;

                const payload = {
                    sender: 'Soporte VIP',
                    text: text
                };

                // Enrutamiento condicional:
                if (currentActiveChatType === 'client') {
                    payload.targetTgId = currentActiveChatId;
                } else if (currentActiveChatType === 'room') {
                    payload.roomId = currentActiveChatId;
                }

                window.operatorSocket.emit('send_message', payload);
                appendMessage('Tú', text, true);
                chatInput.value = '';
            };

            sendBtn.onclick = sendMessage;
            chatInput.onkeypress = (e) => { if (e.key === 'Enter') sendMessage(); };
        }

        function appendMessage(sender, text, isMine) {
            const msgDiv = document.createElement('div');
            msgDiv.style.padding = "10px 15px";
            msgDiv.style.borderRadius = "8px";
            msgDiv.style.maxWidth = "80%";
            msgDiv.style.fontSize = "0.9rem";
            msgDiv.style.marginBottom = "10px";
            
            if (isMine) {
                msgDiv.style.background = "#064e3b";
                msgDiv.style.color = "white";
                msgDiv.style.alignSelf = "flex-end";
                msgDiv.style.borderBottomRightRadius = "0";
                msgDiv.innerHTML = `<b style="color:#D4AF37;">${sender}:</b> ${text}`;
            } else {
                msgDiv.style.background = "#334155";
                msgDiv.style.color = "white";
                msgDiv.style.alignSelf = "flex-start";
                msgDiv.style.borderBottomLeftRadius = "0";
                msgDiv.innerHTML = `<b style="color:#60a5fa;">${sender}:</b> ${text}`;
            }
            
            messagesArea.appendChild(msgDiv);
            messagesArea.scrollTop = messagesArea.scrollHeight;
        }
    };

    // --- ARRANQUE INICIAL ---
    loadGlobalData().then(() => {
        renderHome();
    });

    return page;
}